<template>
  <div class="order-details-page">
    <!-- 订单状态区域 -->
    <div class="order-status-section">
      <div class="status-header">
        <div class="status-badge">
          <img
            src="@/assets/order/payment-status-icon.png"
            alt="" class="status-icon" />
          <span class="status-text">{{ orderInfo.paymentStatus }}</span>
          <img
            src="@/assets/order/delivery-status-icon.png"
            alt="" class="status-icon" />
          <span class="status-text">{{ orderInfo.deliveryStatus }}</span>
        </div>
      </div>

      <div class="order-basic-info">
        <div class="info-left">
          <p>订单号: {{ orderInfo.documentNumber }}</p>
          <p>下单时间: {{ orderInfo.documentTime }}</p>
        </div>
        <div class="info-right">
          <p>供方: {{ orderInfo.sellerName }}/{{ orderInfo.sellerEnterpriseName }}/{{ orderInfo.sellerPhone }}</p>
          <p>需方: {{ orderInfo.buyerName }}/{{ orderInfo.buyerEnterpriseName }}/{{ orderInfo.buyerPhone }}</p>
        </div>
      </div>

      <img class="order-divider"
        src="@/assets/order/divider-line.png"
        alt="" />

      <!-- 合同签订和付款进度 -->
      <div class="contract-payment-section">
        <!-- 合同签订 -->
        <div class="process-section contract-section">
          <div class="section-title-vertical contract-title">
            <span>合</span>
            <span>同</span>
            <span>签</span>
            <span>订</span>
          </div>
          <div class="process-content">
            <div class="process-item">
              <div class="item-label">供应商合同</div>
              <div class="item-status-with-arrow">
                <div class="item-status">
                  <img
                    src="@/assets/order/contract-check-icon.png"
                    alt="" class="status-icon-sm" />
                  <span>{{ orderInfo.contractFiles && orderInfo.contractFiles.length ? '合同已上传' : '待上传合同' }}</span>
                </div>
                <img
                  src="@/assets/order/arrow-right.png"
                  alt="" class="arrow-icon" />
              </div>
              <div v-if="orderInfo.supplierContractTime" class="item-time">{{ orderInfo.supplierContractTime }}</div>
            </div>

            <div class="process-item">
              <div class="item-label">客户合同</div>
              <div class="item-status">
                <img
                  src="@/assets/order/contract-check-icon.png"
                  alt="" class="status-icon-sm" />
                <span>{{ orderInfo.backContractFiles && orderInfo.backContractFiles.length ? '合同已回传' : '待回传合同' }}</span>
              </div>
              <div v-if="orderInfo.customerContractTime" class="item-time">{{ orderInfo.customerContractTime }}</div>
            </div>
          </div>
        </div>

        <img class="section-divider-vertical"
          src="@/assets/order/vertical-divider.png"
          alt="" />

        <!-- 付款进度 -->
        <div class="process-section payment-section">
          <div class="section-title-vertical payment-title">
            <span>付</span>
            <span>款</span>
            <span>进</span>
            <span>度</span>
          </div>
          <div class="process-content">
            <div class="process-item" v-for="(payment, index) in paymentList" :key="index">
              <div class="item-status-with-arrow">
                <div class="item-status">
                  <img
                    src="@/assets/order/payment-check-icon.png"
                    alt="" class="status-icon-sm" />
                  <span>{{ payment.label }}</span>
                </div>
                <img v-if="index < paymentList.length - 1"
                  src="@/assets/order/payment-arrow.png"
                  alt="" class="arrow-icon" />
              </div>
              <div class="item-amount" v-if="payment.amount">¥{{ payment.amount }}元</div>
              <div class="item-time">{{ payment.time }}</div>
              <div class="item-note" v-if="payment.note">{{ payment.note }}</div>
            </div>
          </div>
        </div>
      </div>

      <img class="order-divider"
        src="@/assets/order/divider-line2.png"
        alt="" />

      <!-- 发货进度 -->
      <div class="process-section delivery-section">
        <div class="section-title-vertical delivery-title">
          <span>发</span>
          <span>货</span>
          <span>进</span>
          <span>度</span>
        </div>
        <div class="delivery-content-wrapper">
          <!-- 现货部分 -->
          <div class="stock-row">
            <div class="delivery-node">
              <div class="node-title">
                <img src="@/assets/order/status-dot-icon.png" alt="" class="node-icon" />
                <span>现货部分</span>
              </div>
              <span class="node-time">{{ deliveryProgress.stockTime }}</span>
            </div>
          </div>

          <!-- 出库单流程 -->
          <div class="warehouse-flows">
            <div class="delivery-row" v-for="(warehouse, index) in deliveryProgress.warehouses" :key="index">
              <!-- 出库单 -->
              <div class="delivery-node">
                <div class="node-badge">{{ warehouse.name }}</div>
                <span class="node-time">{{ warehouse.time }}</span>
              </div>

              <!-- 流程节点 -->
              <template v-for="(step, stepIndex) in warehouse.steps" :key="stepIndex">
                <img src="@/assets/order/delivery-arrow.png" alt="" class="connect-arrow" />
                <div class="delivery-node">
                  <div class="node-title">
                    <img src="@/assets/order/status-dot-icon.png" alt="" class="node-icon" />
                    <span v-html="step.label"></span>
                  </div>
                  <span class="node-time">{{ step.time }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 买卖合同 -->
    </div>
    <div class="contract">
      <!-- 左侧：卖方合同 -->
      <div class="contract-section">
        <div class="section-title-vertical contract-vertical-title seller-title">
          <span>卖</span>
          <span>方</span>
          <span>合</span>
          <span>同</span>
        </div>

        <div class="contract-main">
          <!-- 右上角按钮 -->
          <div class="contract-actions">
            <button v-if="isSeller && canEditContracts" class="btn-modify" @click="editSellerContract">修改合同</button>
            <button v-if="isSeller && sellerContractEditing && canEditContracts" class="btn-confirm" @click="confirmSellerContract">确认合同</button>
          </div>

          <!-- 合同内容区 -->
          <div class="contract-content">
            <!-- 左侧合同 -->
            <div class="contract-item contract-item-left seller-contract-left">
              <div v-if="isSeller" class="contract-badge supplier seller-contract-badge" @click="previewContract">使用合同模板</div>
              <div class="contract-preview contract-preview-empty contract-preview-shell">
                <span class="contract-empty-text">暂无卖方合同</span>
                <div
                  v-if="sellerPreviewFile"
                  class="contract-preview-overlay"
                >
                  <img
                    class="contract-img contract-stage-image"
                    :src="sellerPreviewFile.url"
                    alt="卖方合同"
                    @click="openImagePreview(sellerContractDisplayFiles, safeSellerPreviewIndex, 'seller', isBuyer ? 'buyer' : 'seller')"
                  />
                  <button
                    v-if="sellerContractEditing && canEditContracts"
                    type="button"
                    class="contract-delete-btn"
                    @click.stop="removeSellerContractFile(safeSellerPreviewIndex)"
                  >
                    ×
                  </button>
                </div>
                <button
                  v-if="showSellerPreviewArrows"
                  class="contract-stage-nav contract-stage-nav-prev"
                  type="button"
                  @click.stop="switchContractPreview('seller', -1)"
                >
                  ‹
                </button>
                <button
                  v-if="showSellerPreviewArrows"
                  class="contract-stage-nav contract-stage-nav-next"
                  type="button"
                  @click.stop="switchContractPreview('seller', 1)"
                >
                  ›
                </button>
                <span v-if="showSellerPreviewArrows" class="contract-preview-count">
                  {{ safeSellerPreviewIndex + 1 }}/{{ sellerContractDisplayFiles.length }}
                </span>
              </div>
            </div>

            <!-- 右侧合同 -->
            <div v-if="isSeller && sellerContractEditing && canEditContracts" class="contract-item contract-item-slider">
              <upload-file
                :key="sellerUploadKey"
                v-model="maiIds"
                class="contract-uploader"
                isType="drag"
                :img="img"
                :isStamp="true"
                list-type="picture-card"
                :show-file-list="false"
                @usuccess="contractSuccess"
                @delete="sellerContractDelete"
                @autoFill="handleSellerAutoFill"
                :disabled="maiUL"
                :limit="3"
                :list="emptyUploadList"
              />
            </div>

          </div>
        </div>
      </div>
      <!-- 左侧：买方合同 -->
      <div class="contract-section">
        <div class="section-title-vertical contract-vertical-title buyer-title">
          <span>买</span>
          <span>方</span>
          <span>合</span>
          <span>同</span>
        </div>

        <div class="contract-main">
          <!-- 右上角按钮 -->
          <div class="contract-actions">
            <button v-if="canEditContracts" class="btn-modify" @click="editBuyerContract">修改合同</button>
            <button v-if="buyerContractEditing && canEditContracts" class="btn-confirm" @click="confirmBuyerContract">确认合同</button>
          </div>

          <!-- 合同内容区 -->
          <div class="contract-content buyer-contract-content">
            <!-- 左侧合同 -->
            <div class="contract-item contract-item-left buyer-contract-left">
              <div v-if="isBuyer && canEditContracts" class="buyer-contract-stamp-area">
                <div
                  class="contract-badge supplier buyer-contract-stamp-badge"
                  @click="openBuyerContractAutoStamp"
                >
                  自动盖章
                </div>
              </div>
              <div class="contract-preview contract-preview-empty contract-preview-shell">
                <span class="contract-empty-text">暂无买方合同</span>
                <div v-if="buyerPreviewFile" class="contract-preview-overlay">
                  <img
                    class="contract-img contract-stage-image"
                    :src="buyerPreviewFile.url"
                    alt="买方合同"
                    @click="openImagePreview(buyerContractDisplayFiles, safeBuyerPreviewIndex, 'buyer')"
                  />
                  <button
                    v-if="buyerContractEditing && canEditContracts"
                    type="button"
                    class="contract-delete-btn"
                    @click.stop="removeBuyerContractFile(safeBuyerPreviewIndex)"
                  >
                    ×
                  </button>
                </div>
                <button
                  v-if="showBuyerPreviewArrows"
                  class="contract-stage-nav contract-stage-nav-prev"
                  type="button"
                  @click.stop="switchContractPreview('buyer', -1)"
                >
                  ‹
                </button>
                <button
                  v-if="showBuyerPreviewArrows"
                  class="contract-stage-nav contract-stage-nav-next"
                  type="button"
                  @click.stop="switchContractPreview('buyer', 1)"
                >
                  ›
                </button>
                <span v-if="showBuyerPreviewArrows" class="contract-preview-count">
                  {{ safeBuyerPreviewIndex + 1 }}/{{ buyerContractDisplayFiles.length }}
                </span>
              </div>
              <span v-if="buyerPreviewFile" class="buyer-contract-upload-tip">{{ buyerContractUploadTip }}</span>
            </div>

            <!-- 右侧合同 -->
            <div v-if="buyerContractEditing && canEditContracts" class="contract-item contract-item-slider">
              <upload-file
                :key="buyerUploadKey"
                v-model="ids"
                class="contract-uploader"
                isType="drag"
                list-type="picture-card"
                :show-file-list="false"
                @usuccess="buyerContractUploadSuccess"
                @delete="buyerContractDelete"
                :limit="3"
                :list="emptyUploadList"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contract pay-info">
      <!-- 左侧：卖方合同 -->
      <div class="contract-section pay-info-section">
        <div class="section-title-vertical contract-vertical-title pay-info-title">
          <span>付</span>
          <span>款</span>
          <span>信</span>
          <span>息</span>
        </div>

        <div class="contract-main">
          <!-- 右上角按钮 -->
          <div class="contract-actions pay-info-actions">
            <button
              v-if="isSeller"
              class="btn-modify collection-qr-toggle"
              @click="handleCollectionQrCodeToggle"
            >
              {{ collectionQrCodeEnabled ? '关闭收款码' : '启用收款码' }}
            </button>
            <div
              v-if="showPayExtraActions"
              class="contract-badge supplier pay-action-immediate"
              @click="collection"
            >
              立即支付
            </div>
            <button class="btn-modify pay-action-secondary" @click="handleModifyPayVoucher">修改底单</button>
            <button v-if="showPayExtraActions" class="btn-confirm pay-action-primary" @click="goRecord">确认底单</button>
          </div>

          <!-- 合同内容区 -->
          <div class="contract-content pay-info-content">
            <div
              v-if="isBuyer && collectionQrCodeEnabled"
              class="contract-item collection-qr-item"
              title="点击查看收款码"
            >
              <div class="collection-qr-title">收款码</div>
              <img
                v-if="sellerCollectionQrCodeFile"
                class="collection-qr-image"
                :src="sellerCollectionQrCodeFile.url"
                alt="卖方收款码"
                @click="showCollectionQrCode"
              />
            </div>
            <!-- 左侧合同 -->
            <div class="contract-item contract-item-left payment-status-item">
              <div class="payment-status-card">
                <div class="payment-status-header">
                  <span class="payment-status-icon">!</span>
                  <span class="payment-status-text">{{ orderInfo.isPayText || orderInfo.paymentStatus }}</span>
                </div>
                <div class="payment-status-row">
                  <span class="payment-status-label">已付款:</span>
                  <span class="payment-status-value">¥{{ formatMoney(orderInfo.paidAmount || 0) }}</span>
                </div>
                <div class="payment-status-row payment-status-row-total">
                  <span class="payment-status-label">全款:</span>
                  <span class="payment-status-value">¥{{ formatMoney(orderInfo.totalAmount || orderSummary.totalAmount || 0) }}</span>
                </div>
              </div>
            </div>

            <!-- 右侧合同 -->
            <div class="contract-item pay-voucher-item">
              <div
                :class="['pay-voucher-card', { 'has-file': orderInfo.payFiles && orderInfo.payFiles.length }]"
                @click="handlePayVoucherCardClick"
              >
                <template v-if="orderInfo.payFiles && orderInfo.payFiles.length">
                  <img
                    class="contract-img pay-voucher-image"
                    :src="orderInfo.payFiles[0].url"
                    alt="支付凭证"
                  />
                  <div class="pay-voucher-mask">查看底单</div>
                </template>
                <template v-else>
                  <img src="@/assets/icons/order/imgInset.png" alt="上传底单" class="pay-voucher-upload-icon" />
                  <div class="pay-voucher-upload-text">上传底单</div>
                  <div class="pay-voucher-upload-hint">
                    图片格式支持JPG/PNG,<br />
                    单张上传2M以内。
                  </div>
                </template>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="contract-section">
        <div class="section-title-vertical contract-vertical-title shipping-status-title">
          <span>发</span>
          <span>货</span>
          <span>状</span>
          <span>态</span>
        </div>

        <div class="contract-main">
          <!-- 右上角按钮 -->
          <div class="contract-actions">
            <button v-if="isSeller" class="btn-modify" @click="sendGoods">发货</button>
            <button
              v-if="isBuyer"
              class="btn-confirm"
              :disabled="currentShipReceiptConfirmed"
              :title="currentShipReceiptConfirmed ? currentShipReceiptTip : ''"
              @click="openReceiptDialog"
            >
              确认收货
            </button>
          </div>

          <!-- 合同内容区 -->
          <div class="contract-content shipping-status-content">
            <div v-if="isSeller || isBuyer" class="shipping-status-slider">
              <template v-if="shippingStatusDisplayFiles.length">
                <div class="shipping-status-preview-card" @click="handleShippingStatusImageClick(safeShippingStatusPreviewIndex)">
                  <img
                    class="shipping-status-thumb-image"
                    :src="shippingStatusPreviewFile.url"
                    :alt="shippingStatusDisplayTitle"
                  />
                  <div class="shipping-status-thumb-mask">查看图片</div>
                  <button
                    v-if="showShippingStatusPreviewArrows"
                    class="shipping-status-nav shipping-status-nav-prev"
                    type="button"
                    @click.stop="switchShippingStatusPreview(-1)"
                  >
                    ‹
                  </button>
                  <button
                    v-if="showShippingStatusPreviewArrows"
                    class="shipping-status-nav shipping-status-nav-next"
                    type="button"
                    @click.stop="switchShippingStatusPreview(1)"
                  >
                    ›
                  </button>
                  <span v-if="showShippingStatusPreviewArrows" class="shipping-status-count">
                    {{ safeShippingStatusPreviewIndex + 1 }}/{{ shippingStatusDisplayFiles.length }}
                  </span>
                </div>
              </template>
              <div v-else class="contract-item pay-voucher-item">
                <div class="pay-voucher-card">
                  <div class="contract-upload-area">
                    <img src="@/assets/icons/order/imgInset.png" alt="上传" class="upload-icon" />
                    <div class="upload-text">{{ shippingStatusDisplayTitle }}</div>
                    <div class="upload-hint">
                      {{ shippingStatusDisplayEmptyText }}<br />
                      图片格式支持JPG/PNG,单张上传2M以内.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左侧：买方合同 -->
      <div class="contract-section">
        <div class="section-title-vertical contract-vertical-title billing-information-title">
          <span>开</span>
          <span>票</span>
          <span>信</span>
          <span>息</span>
        </div>

        <div class="contract-main">
          <!-- 右上角按钮 -->
          <div class="contract-actions">
            <button v-if="isSeller" class="btn-modify" @click="showInvoiceUploader">
              {{ invoiceActionText }}
            </button>
            <button v-if="invoiceDisplayFiles.length" class="btn-confirm" @click="downloadInvoice">下载发票</button>
          </div>

          <!-- 合同内容区 -->
          <div class="contract-content">
            <!-- 左侧合同 -->
            <div class="contract-item contract-item-left buyer-contract-left">
              <div class="contract-preview contract-preview-empty contract-preview-shell">
                <span v-if="!invoicePreviewFile" class="contract-empty-text">暂无发票</span>
                <div v-if="invoicePreviewFile" class="contract-preview-overlay">
                  <img
                    class="contract-img contract-stage-image"
                    :src="invoicePreviewFile.url"
                    alt="发票"
                    @click="openImagePreview(invoiceDisplayFiles, safeInvoicePreviewIndex, 'invoice')"
                  />
                  <button
                    v-if="isSeller && invoiceEditing"
                    type="button"
                    class="contract-delete-btn"
                    @click.stop="removeInvoiceFile(safeInvoicePreviewIndex)"
                  >
                    ×
                  </button>
                </div>
                <button
                  v-if="showInvoicePreviewArrows"
                  class="contract-stage-nav contract-stage-nav-prev"
                  type="button"
                  @click.stop="switchInvoicePreview(-1)"
                >
                  ‹
                </button>
                <button
                  v-if="showInvoicePreviewArrows"
                  class="contract-stage-nav contract-stage-nav-next"
                  type="button"
                  @click.stop="switchInvoicePreview(1)"
                >
                  ›
                </button>
                <span v-if="showInvoicePreviewArrows" class="contract-preview-count">
                  {{ safeInvoicePreviewIndex + 1 }}/{{ invoiceDisplayFiles.length }}
                </span>
              </div>
            </div>

            <!-- 右侧合同 -->
            <div v-if="isSeller && invoiceEditing" class="contract-item contract-item-slider">
              <upload-file
                :key="invoiceUploadKey"
                v-model="invoiceFileIds"
                class="contract-uploader"
                isType="drag"
                list-type="picture-card"
                :show-file-list="false"
                :limit="5"
                :list="pendingInvoiceFiles"
                onlyImage
                accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                :maxSizeMb="2"
                @usuccess="handleInvoiceUploadSuccess"
                @delete="handleInvoiceUploadDelete"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="order-divider"
      src="@/assets/order/divider-line2.png"
      alt="" />


    <!-- 出库单信息 -->
    <div class="warehouse-section">
      <div class="warehouse-tabs">
        <div v-for="(tab, index) in warehouseTabs" :key="index"
          :class="['warehouse-tab-item', { active: currentWarehouseTab === index }]"
          @click="currentWarehouseTab = index">
          {{ tab }}
        </div>
      </div>

      <div class="warehouse-content">
        <!-- 左侧：发货单号和发货城市 -->
        <div class="warehouse-left">
          <div class="warehose-title">
            <div class="warehouse-info-row first-title">
              <span class="info-label">发货单号:</span>
              <span class="info-value">{{ currentWarehouseData.trackingNo }}</span>
              <button
                v-if="currentShipRecord && currentShipRecord.undoFlag === '0' && isSeller"
                type="button"
                class="void-shipment-button"
                @click="removeGoods(currentShipRecord)"
              >
                作废发货单
              </button>
              <span
                v-else-if="currentShipRecord && currentShipRecord.undoFlag === '1'"
                class="void-shipment-status"
              >
                已作废
              </span>
            </div>
            <div class="warehouse-info-row">
              <span class="info-label">发货城市:</span>
              <span class="info-value">{{ currentWarehouseData.city }}</span>
            </div>
          </div>

          <!-- 物流时间线 -->
          <div class="logistics-timeline">
            <div v-for="(item, index) in currentWarehouseData.timeline" :key="index"
              :class="['timeline-item', { 'is-latest': index === 0 }]">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-time">{{ item.time }}</div>
                <div class="timeline-text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="warehouse-right">
          <!-- 包裹信息区域 -->
          <div class="package-section">
            <!-- 包裹头部 - Tab和信息在同一行 -->
            <div class="package-header">
              <div class="package-tabs">
                <div class="package-tab-item active">包裹1</div>
              </div>
              <div class="package-info">
                <span class="info-label">物流公司:</span>
                <span class="info-value">{{ currentWarehouseData.logisticsCompany }}</span>
                <span class="info-label">单号:</span>
                <span class="info-value">{{ currentWarehouseData.logisticsNo }}</span>
              </div>
            </div>

            <!-- 包裹时间轴 -->
            <div class="package-timeline">
              <div v-for="(item, index) in currentWarehouseData.packageTimeline" :key="index"
                :class="['timeline-item', { 'is-latest': index === 0 }]">
                <div class="timeline-dot"></div>
                <div class="timeline-content">
                  <div class="timeline-time">{{ item.time }}</div>
                  <div class="timeline-text">{{ item.text }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 出库清单 -->
    <div class="warehouse-list">
      <div class="warehouse-list-header">
        <span class="header-title">出库清单</span>
        <span class="download-link">下载清单</span>
      </div>

      <PurchaseTable :table-data="currentWarehouseProducts" :columns="warehouseColumns" :loading="false"
        :show-expand="false" :show-operation="false" :show-toolbar="false"
        :page-info="{ pageNum: 1, pageSize: 20, total: currentWarehouseProducts.length }">
        <template #productName="{ row }">
          <div class="product-name-cell">
            <span class="brand-tag">品牌名</span>
            <span class="product-text">{{ row.productName }}</span>
          </div>
        </template>
      </PurchaseTable>
    </div>

    <!-- 收货信息、收票地址、发票信息 -->
    <div class="info-cards-section">
      <div class="info-card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>收货信息</span>
        </div>
        <div class="card-content">
          <div class="content-row">
            <p>收货人: {{ receiverInfo.name || '-' }}</p>
            <div class="card-action" @click="copyReceiverInfo">一键复制</div>
          </div>
          <p>地址: {{ receiverInfo.address || '-' }}</p>
          <p>电话: {{ receiverInfo.phone || '-' }}</p>
        </div>
      </div>

      <div class="info-card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>收票地址</span>
        </div>
        <div class="card-content">
          <div class="content-row">
            <p>收票人: {{ invoiceReceiverInfo.name }}</p>
            <div class="card-action" @click="copyInvoiceReceiverInfo">一键复制</div>
          </div>
          <p>收票邮箱: {{ invoiceReceiverInfo.email || '-' }}</p>
          <p>电话: {{ invoiceReceiverInfo.phone || '-' }}</p>
        </div>
      </div>

      <div class="info-card">
        <div class="card-title">
          <span class="title-icon"></span>
          <span>发票信息</span>
        </div>
        <div class="card-content">
          <div class="content-row">
            <p>公司名称: {{ invoiceInfo.companyName || '-' }}</p>
            <div class="card-action" @click="copyInvoiceInfo">一键复制</div>
          </div>
          <p>税务登记证号: {{ invoiceInfo.taxNo || '-' }}</p>
          <p>公司开户行名称: {{ invoiceInfo.bankName || '-' }}</p>
          <p>公司开户行账号: {{ invoiceInfo.bankAccount || '-' }}</p>
          <p>注册场所地址: {{ invoiceInfo.address || '-' }}</p>
          <p>注册固定电话: {{ invoiceInfo.phone || '-' }}</p>
          <!-- <p>发票类型: {{ invoiceInfo.type }}</p> -->
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div class="product-list-section">
      <div class="product-tabs">
        <div :class="['tab-item', { active: currentProductTab === 'all' }]" @click="currentProductTab = 'all'">全部</div>
        <div :class="['tab-item', { active: currentProductTab === 'shipped' }]" @click="currentProductTab = 'shipped'">已发货</div>
      </div>

      <PurchaseTable 
        :table-data="filteredProductList" 
        :columns="productColumns" 
        :loading="false"
        :show-expand="false" 
        :show-operation="false" 
        :show-toolbar="false"
        :show-pagination="false"
        :auto-height="true"
        :page-info="{ pageNum: 1, pageSize: 20, total: filteredProductList.length }">
        <template #productInfo="{ row }">
          <div class="product-info-cell">
            <div class="product-header">
              <span class="product-brand-tag">{{ row.brandName }}</span>
              <span class="product-name">{{ row.productName }}</span>
            </div>
            <div class="product-detail-line">订货号: {{ row.orderNo }}</div>
            <div class="product-detail-line">型号: {{ row.model }}</div>
            <div v-if="row.packingSpec" class="product-detail-line">包装规格: {{ row.packingSpec }}</div>
            <div class="product-detail-line">市场价: {{ row.marketPrice }}</div>
            <div v-if="row.afterSalesPolicy" class="product-detail-line after-sales">售后政策: {{ row.afterSalesPolicy }}</div>
          </div>
        </template>
        <template #channel="{ row }">
          <div class="channel-tag" :class="row.channelType">{{ row.channel }}</div>
        </template>
        <template #salePrice="{ row }">
          <span class="price-text">{{ row.salePrice }}</span>
        </template>
        <template #total="{ row }">
          <span class="total-text">{{ row.total }}</span>
        </template>
      </PurchaseTable>

      <!-- 订单汇总 -->
      <div class="order-summary">
        <div class="summary-left">
          <div class="summary-item">
            <span class="label">货品种类:</span>
            <span class="value">{{ orderSummary.productTypes }}种</span>
          </div>
          <div class="summary-item">
            <span class="label">总计数量:</span>
            <span class="value">{{ orderSummary.totalQuantity }}件</span>
          </div>
          <div class="summary-item">
            <span class="label">备注:</span>
            <span class="value">{{ orderSummary.remark || '-' }}</span>
          </div>
        </div>
        <div class="summary-right">
          <div class="summary-row">
            <span class="label">订单金额:</span>
            <span class="value">¥{{ orderSummary.orderAmount }}元</span>
          </div>
          <div class="summary-row">
            <span class="label">商品总计:</span>
            <span class="value">¥{{ orderSummary.productTotal }}元</span>
          </div>
          <div class="summary-row">
            <span class="label">运费:</span>
            <span class="value">¥{{ orderSummary.shippingFee }}元</span>
          </div>
          <div class="summary-row">
            <span class="label">代发服务费:</span>
            <span class="value">¥{{ orderSummary.serviceFee }}元</span>
          </div>
          <div class="summary-row total">
            <span class="label">应付金额:</span>
            <span class="value total-amount">¥{{ orderSummary.totalAmount }}元</span>
          </div>
        </div>
      </div>
    </div>
    <collectionDialog
      v-model="collectionShow"
      :orderInfo="orderInfo"
      :oid="$route.query.id"
      :files="orderInfo.payFiles || []"
      @success="sendSuccess"
      @upSuccess="confirmPayment"
    />
    <collectionRecord v-model="showCollectionRecord" :pid="$route.query.id" />
    <send-googd-dialog
      v-model="sendGoogdShow"
      :orderInfo="orderInfo"
      :oid="$route.query.id"
      @success="sendSuccess"
    />
    <receipt-goods-dialog
      v-model="receiptDialogShow"
      :oid="$route.query.id"
      :ship-id="currentReceiptShipId"
      @success="sendSuccess"
    />
    <teleport to="body">
      <div
        v-if="imagePreviewVisible"
        class="order-image-viewer"
        @click.self="closeImagePreview"
        @wheel.prevent
      >
        <button type="button" class="order-image-viewer-close" @click.stop="closeImagePreview">×</button>
        <button
          v-if="imagePreviewList.length > 1"
          type="button"
          class="order-image-viewer-nav order-image-viewer-prev"
          @click.stop="switchImagePreview(-1)"
        >
          ‹
        </button>
        <div v-if="currentImagePreviewUrl" ref="orderStampCapture" class="order-image-viewer-content" @click.stop>
          <img
            class="order-image-viewer-img"
            :src="imagePreviewCaptureUrl || currentImagePreviewUrl"
            alt="合同预览"
          />
          <img
            v-if="imagePreviewStamped"
            ref="orderStampSeal"
            class="order-image-viewer-seal"
            :class="{ 'is-dragging': imagePreviewSealDragging }"
            :style="imagePreviewSealStyle"
            :src="img"
            alt="合同章"
            title="按住拖动可调整盖章位置"
            @pointerdown.stop.prevent="startImagePreviewSealDrag"
          />
          <img
            v-if="imagePreviewSeamStamped"
            class="order-image-viewer-seal is-seam-stamp"
            :src="img"
            alt="合同骑缝章"
            title="骑缝章"
          />
        </div>
        <button
          v-if="imagePreviewList.length > 1"
          type="button"
          class="order-image-viewer-nav order-image-viewer-next"
          @click.stop="switchImagePreview(1)"
        >
          ›
        </button>
        <div v-if="imagePreviewList.length > 1" class="order-image-viewer-count">
          {{ imagePreviewIndex + 1 }}/{{ imagePreviewList.length }}
        </div>
        <div v-if="currentImagePreviewUrl" class="order-image-viewer-actions" @click.stop>
          <button type="button" class="order-image-viewer-action" @click="downloadImagePreview">下载附件</button>
          <button v-if="canStampImagePreview" type="button" class="order-image-viewer-action" @click="stampImagePreview">盖章</button>
          <button v-if="canStampImagePreview" type="button" class="order-image-viewer-action" @click="seamStampImagePreview">骑缝章</button>
          <template v-if="canStampImagePreview && imagePreviewStamped">
            <button type="button" class="order-image-viewer-action order-image-viewer-scale-action" @click="resizeImagePreviewSeal(-20)">缩小</button>
            <button type="button" class="order-image-viewer-action order-image-viewer-scale-action" @click="resizeImagePreviewSeal(20)">放大</button>
          </template>
          <button
            v-if="canStampImagePreview"
            type="button"
            class="order-image-viewer-action order-image-viewer-action-primary"
            :disabled="!hasImagePreviewStamp || imagePreviewUploading"
            @click="confirmImagePreviewStamp"
          >
            {{ imagePreviewUploading ? '上传中...' : '确认' }}
          </button>
        </div>
      </div>
    </teleport>
  </div>
</template>

<script>
import PurchaseTable from '@/components/publicComponent/purchasePage/PurchaseTable.vue';
import { mapActions, mapState } from 'vuex';
import { ElMessage, ElMessageBox } from 'element-plus';
import collectionDialog from '../components/dialog/collection.vue';
import collectionRecord from '../components/dialog/collectionRecord.vue';
import sendGoogdDialog from '../components/dialog/sendGoogd.vue';
import receiptGoodsDialog from '../components/dialog/receiptGoods.vue';
import { convertCurrency } from '../mixins/handleAmount';
import uploadFile from '@/components/publicComponent/uploadFile.vue';
import html2Canvas from 'html2canvas';
import request from '@/common/js/request.js';
import api from '@/common/js/api.js';
import { copyText, downLoadFile } from '@/common/js/common.js';

export default {
  name: 'XinOrderDetails',
  components: {
    PurchaseTable,
    collectionDialog,
    collectionRecord,
    sendGoogdDialog,
    receiptGoodsDialog,
    uploadFile
  },
  data() {
    return {
      ids: [],
      maiIds: [],
      img: '',
      sellerContractIds: [],
      buyerContractIds: [],
      contractSliderVisibleCount: 3,
      sellerPreviewIndex: 0,
      buyerPreviewIndex: 0,
      invoicePreviewIndex: 0,
      sellerContractEditing: false,
      buyerContractEditing: false,
      invoiceEditing: false,
      pendingSellerContractIds: [],
      pendingBuyerContractIds: [],
      invoiceFileIds: [],
      invoiceUploadKey: 0,
      pendingAutoFillBuyerIds: [],
      pendingSellerContractFiles: [],
      pendingBuyerContractFiles: [],
      pendingInvoiceFiles: [],
      imagePreviewVisible: false,
      imagePreviewList: [],
      imagePreviewIndex: 0,
      imagePreviewType: '',
      imagePreviewSaveType: '',
      imagePreviewStamped: false,
      imagePreviewSeamStamped: false,
      imagePreviewUploading: false,
      imagePreviewCaptureUrl: '',
      imagePreviewSealPosition: null,
      imagePreviewSealWidth: 210,
      imagePreviewSealDragging: false,
      imagePreviewSealDragOffset: null,
      emptyUploadList: [],
      sellerUploadKey: 0,
      buyerUploadKey: 0,
      userId: '',
      info: {},
      seller: {},
      sellerEnterpriseLoadedId: '',
      buyer: {},
      formValues1: {
        consigneeName: null,
        consigneePhone: null,
        area: [],
        receiveAddress: null
      },
      formValues2: {
        consigneeName: null,
        consigneePhone: null,
        area: [],
        receiveAddress: null
      },
      activeSg: 0,
      collectionShow: false,
      payActionExpanded: false,
      shippingStatusPreviewIndex: 0,
      showCollectionRecord: false,
      receiptDialogShow: false,
      currentReceiptShipId: '',
      sendGoogdShow: false,
      total: '',
      collectionRecords: [],
      currentProductTab: 'all', // 当前产品列表tab: 'all' 或 'shipped'
      productColumns: [
        { prop: 'productInfo', label: '产品信息', minWidth: 300 },
        { prop: 'channel', label: '渠道', width: 100, align: 'center' },
        { prop: 'salePrice', label: '卖价', width: 100, align: 'center' },
        { prop: 'quantity', label: '数量', width: 80, align: 'center' },
        { prop: 'total', label: '总计', width: 100, align: 'center' },
        { prop: 'deliveryTime', label: '参考货期时效', minWidth: 180 }
      ],
      warehouseColumns: [
        { prop: 'productName', label: '产品名称', minWidth: 200 },
        { prop: 'orderNo', label: '订货号', align: 'center' },
        { prop: 'model', label: '型号', align: 'center' },
        { prop: 'quantity', label: '数量', align: 'center' }
      ],
      orderInfo: {
        documentNumber: '',
        documentTime: '',
        paymentStatus: '',
        deliveryStatus: '',
        sellerName: '',
        sellerEnterpriseName: '',
        sellerPhone: '',
        buyerName: '',
        buyerEnterpriseName: '',
        buyerPhone: '',
        supplierContractTime: '',
        customerContractTime: ''
      },
      paymentList: [
        { label: '回传', time: '2025-12-10 15:42:43' },
        { label: '付预付款', amount: '3862.50', time: '2025-12-10 15:42:43', note: '垫款退还' },
        { label: '付尾款', amount: '3862.50', time: '2025-12-10 15:42:43' }
      ],
      deliveryProgress: {
        stockTime: '',
        warehouses: []
      },
      deliveryGroups: [],
      warehouseTabs: [],
      currentWarehouseTab: 0,
      warehouseData: [],
      warehouseProducts: [],
      receiverInfo: {
        name: '',
        address: '',
        phone: ''
      },
      invoiceReceiverInfo: {
        name: '',
        email: '',
        phone: ''
      },
      invoiceInfo: {
        companyName: '',
        taxNo: '',
        bankName: '',
        bankAccount: '',
        address: '',
        phone: '',
        type: '',
        invoiceFiles: []
      },
      invoiceDetailRecord: {},
      productList: [
        {
          brandName: '品牌名',
          productName: '三菱伺服电机',
          orderNo: 'A9F18240',
          model: 'IC65N 2P C40A',
          marketPrice: '¥149.04/只',
          channel: '代理',
          channelType: 'agent',
          salePrice: '0.45折',
          quantity: 2,
          total: '¥109.70',
          deliveryTime: '预计2025-11-26发货 预计2025-11-28前送达',
          isShipped: true
        },
        {
          brandName: '品牌名',
          productName: '三菱伺服电机',
          orderNo: 'A9F18240',
          model: 'IC65N 2P C40A',
          marketPrice: '¥149.04/只',
          channel: '自营',
          channelType: 'self',
          salePrice: '¥54.85',
          quantity: 4,
          total: '¥109.70',
          deliveryTime: '预计2025-11-26发货 预计2025-11-28前送达',
          isShipped: true
        },
        {
          brandName: '品牌名',
          productName: '三菱伺服电机',
          orderNo: 'A9F18240',
          model: 'IC65N 2P C40A',
          packingSpec: '6只/盒，54只/箱',
          marketPrice: '¥149.04/只',
          afterSalesPolicy: '不影响二次销售，发货后15天内无理由退货(仅现货)',
          channel: '厂家',
          channelType: 'factory',
          salePrice: '¥54.85',
          quantity: 5,
          total: '¥109.70',
          deliveryTime: '预计2025-11-26发货 预计2025-11-28前送达',
          isShipped: false
        }
      ],
      orderSummary: {
        productTypes: 3,
        totalQuantity: 4,
        remark: '-',
        orderAmount: '421.84',
        productTotal: '411.84',
        shippingFee: '10.00',
        serviceFee: '0.00',
        totalAmount: '421.84'
      }
    };
  },
  computed: {
    ...mapState('purchaseMudule', [
      'paymentTypes',
      'moneys',
      'documentState',
      'projectState',
      'isPay',
      'shipStatus',
      'courierCompany'
    ]),
    ...mapState(['userInfo']),
    currentUserId() {
      return this.userInfo?.userId || this.userId;
    },
    isBuyer() {
      return this.currentUserId === this.orderInfo.buyerId;
    },
    isSeller() {
      return this.currentUserId === this.orderInfo.sellerId;
    },
    isFullyPaid() {
      return String(this.orderInfo.isPay) === '1';
    },
    collectionQrCodeEnabled() {
      return ['1', 'true', 'TRUE'].includes(String(this.orderInfo.collectionQrCodeEnabled));
    },
    sellerCollectionQrCodeFiles() {
      return this.safeParseFiles(this.getCachedSellerInfo().collectionQrCode);
    },
    sellerCollectionQrCodeFile() {
      return this.sellerCollectionQrCodeFiles.find(item => item && item.url) || null;
    },
    canEditContracts() {
      return !this.isFullyPaid;
    },
    buyerContractUploaderRole() {
      if (this.currentUserId === this.orderInfo.sellerId) {
        return 'SELLER';
      }
      if (this.currentUserId === this.orderInfo.buyerId) {
        return 'BUYER';
      }
      return '';
    },
    buyerContractUploadTip() {
      const uploadUserType = this.orderInfo.backContractUploadUserType;
      if (uploadUserType === 'SELLER') {
        return '由卖方代上传';
      }
      return '买方回传';
    },
    maiUL() {
      return !this.isSeller;
    },
    buyUL() {
      return (
        this.currentUserId !== this.orderInfo.buyerId ||
        String(this.orderInfo.isPay) !== '0' ||
        this.orderInfo.shipStatus !== 'NIL'
      );
    },
    showPayExtraActions() {
      return this.payActionExpanded;
    },
    totalNum() {
      return (this.orderInfo.documentItemResultVOList || []).reduce((sum, item) => {
        return sum + (Number(item.purchaseQty) || 0);
      }, 0);
    },
    sellerContractDisplayFiles() {
      return this.sellerContractEditing
        ? this.pendingSellerContractFiles
        : (this.orderInfo.contractFiles || []);
    },
    sellerPreviewFile() {
      return this.sellerContractDisplayFiles[this.safeSellerPreviewIndex] || null;
    },
    buyerContractDisplayFiles() {
      return this.buyerContractEditing
        ? this.pendingBuyerContractFiles
        : (this.orderInfo.backContractFiles || []);
    },
    buyerPreviewFile() {
      return this.buyerContractDisplayFiles[this.safeBuyerPreviewIndex] || null;
    },
    safeSellerPreviewIndex() {
      if (!this.sellerContractDisplayFiles.length) return 0;
      return Math.min(this.sellerPreviewIndex, this.sellerContractDisplayFiles.length - 1);
    },
    safeBuyerPreviewIndex() {
      if (!this.buyerContractDisplayFiles.length) return 0;
      return Math.min(this.buyerPreviewIndex, this.buyerContractDisplayFiles.length - 1);
    },
    showSellerPreviewArrows() {
      return this.sellerContractDisplayFiles.length > 1;
    },
    showSellerEditArrows() {
      return this.sellerContractEditing && this.sellerContractDisplayFiles.length > this.contractSliderVisibleCount;
    },
    showBuyerPreviewArrows() {
      return this.buyerContractDisplayFiles.length > 1;
    },
    showBuyerEditArrows() {
      return this.buyerContractEditing && this.buyerContractDisplayFiles.length > this.contractSliderVisibleCount;
    },
    invoiceDisplayFiles() {
      return this.invoiceEditing ? this.pendingInvoiceFiles : (this.invoiceInfo.invoiceFiles || []);
    },
    safeInvoicePreviewIndex() {
      if (!this.invoiceDisplayFiles.length) return 0;
      return Math.min(this.invoicePreviewIndex, this.invoiceDisplayFiles.length - 1);
    },
    invoicePreviewFile() {
      return this.invoiceDisplayFiles[this.safeInvoicePreviewIndex] || null;
    },
    showInvoicePreviewArrows() {
      return this.invoiceDisplayFiles.length > 1;
    },
    invoiceActionText() {
      return (this.invoiceInfo.invoiceFiles || []).length ? '修改发票' : '上传发票';
    },
    currentImagePreviewUrl() {
      return this.imagePreviewList[this.imagePreviewIndex] || '';
    },
    canStampImagePreview() {
      return ['seller', 'buyer'].includes(this.imagePreviewType) && this.isBuyer && this.canEditContracts;
    },
    hasImagePreviewStamp() {
      return this.imagePreviewStamped || this.imagePreviewSeamStamped;
    },
    imagePreviewSealStyle() {
      const style = {
        width: `${this.imagePreviewSealWidth}px`
      };
      if (!this.imagePreviewSealPosition) return style;
      return {
        ...style,
        left: `${this.imagePreviewSealPosition.x}px`,
        top: `${this.imagePreviewSealPosition.y}px`,
        right: 'auto',
        bottom: 'auto'
      };
    },
    currentWarehouseData() {
      return this.warehouseData[this.currentWarehouseTab] || {
        trackingNo: '',
        city: '',
        timeline: [],
        logisticsCompany: '',
        logisticsNo: '',
        packageTimeline: []
      };
    },
    currentShipRecord() {
      const shipList = this.orderInfo.purchaseShipResultVOList || [];
      return shipList[this.currentWarehouseTab] || shipList[0] || null;
    },
    currentShipRecordId() {
      return this.currentWarehouseData.shipRecordId || this.getShipRecordId(this.currentShipRecord);
    },
    currentShipReceiptConfirmed() {
      return this.currentShipRecord?.isReceipt === '1' || !!this.currentShipRecord?.receiptTime;
    },
    currentShipReceiptTip() {
      return this.currentShipReceiptConfirmed ? '当前出库单已确认收货，不能重复操作' : '';
    },
    shippingStatusDisplayFiles() {
      if (!this.currentShipRecord) return [];
      return this.isBuyer
        ? (this.currentShipRecord.files || [])
        : (this.currentShipRecord.receiptFiles || []);
    },
    safeShippingStatusPreviewIndex() {
      if (!this.shippingStatusDisplayFiles.length) return 0;
      return Math.min(this.shippingStatusPreviewIndex, this.shippingStatusDisplayFiles.length - 1);
    },
    shippingStatusPreviewFile() {
      return this.shippingStatusDisplayFiles[this.safeShippingStatusPreviewIndex] || null;
    },
    showShippingStatusPreviewArrows() {
      return this.shippingStatusDisplayFiles.length > 1;
    },
    shippingStatusDisplayTitle() {
      return this.isBuyer ? '卖家发货装箱照' : '买家收货回单';
    },
    shippingStatusDisplayEmptyText() {
      return this.isBuyer ? '待卖家上传发货装箱照' : '待买家上传收货回单';
    },
    currentWarehouseProducts() {
      // 根据当前选中的出库单返回对应的产品列表
      return this.warehouseProducts;
    },
    filteredProductList() {
      // 根据当前tab过滤产品列表
      if (this.currentProductTab === 'shipped') {
        return this.productList.filter(item => item.isShipped);
      }
      return this.productList;
    }
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    this.userId = userInfo.userId || '';
    this.loadOrderDetails();
  },
  beforeUnmount() {
    this.stopImagePreviewSealDrag();
  },
  methods: {
    ...mapActions('purchaseMudule', [
      'purchaseUpdatePayment',
      'purchaseUpdateBackContractFile'
    ]),
    ...mapActions('mysaleMudule', {
      inquirySellerInfo: 'inquirySellerInfo',
      purchaseDetails: 'purchaseDetails',
      purchaseGetExpress: 'purchaseGetExpress',
      purchaseUpdateAddress: 'purchaseUpdateAddress',
      getUserInvoiceUserId: 'getUserInvoiceUserId',
      invoiceCreateWithAttachment: 'invoiceCreateWithAttachment',
      fetchInvoiceInfo: 'invoiceInfo',
      purchaseCollectionList: 'purchaseCollectionList',
      purchaseShipUndo: 'purchaseShipUndo',
      purchaseUpdateContractFile: 'purchaseUpdateContractFile',
      purchaseUpdateCollectionQrCodeStatus: 'purchaseUpdateCollectionQrCodeStatus'
    }),
    ...mapActions('myMessageModule', [
      'getEnterprise',
      'userConsigneeList'
    ]),
    ensureContractsEditable() {
      if (!this.isFullyPaid) return true;
      ElMessage.warning('订单已全部支付，合同不可修改、删除或盖章');
      return false;
    },
    loadOrderDetails() {
      this.getOrderInfo();
      this.getDetails();
      this.getInvoiceInfo();
      this.getCollectionRecords();
    },
    safeParseFiles(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    },
    getType(attribute, type) {
      const options = this[attribute] || [];
      const target = options.find(item => item.type === type);
      return target ? target.title : '';
    },
    formatMoney(value) {
      return value === undefined || value === null || value === '' ? '0.00' : value;
    },
    normalizeRows(data) {
      if (Array.isArray(data)) return data;
      if (data && Array.isArray(data.rows)) return data.rows;
      if (data && Array.isArray(data.records)) return data.records;
      if (data && Array.isArray(data.list)) return data.list;
      return [];
    },
    getOrderInfo() {
      if (!this.$route.query.id) return;
      this.purchaseDetails(this.$route.query.id).then(async res => {
        const { code, data } = res.data;
        if (code !== '0' || !data) return;

        const order = {
          ...data,
          contractFiles: this.safeParseFiles(data.contractFiles),
          backContractFiles: this.safeParseFiles(data.backContractFiles),
          payFiles: this.safeParseFiles(data.payFiles),
          purchaseShipResultVOList: (data.purchaseShipResultVOList || []).map(item => ({
            ...item,
            files: this.safeParseFiles(item.files),
            receiptFiles: this.safeParseFiles(item.receiptFiles)
          }))
        };
        order.documentState = this.documentState[order.documentStatus];
        order.isPayText = this.getType('isPay', order.isPay);
        order.shipStatusText = this.getType('shipStatus', order.shipStatus);
        order.paymentStatus = order.isPayText || this.orderInfo.paymentStatus;
        order.deliveryStatus = order.shipStatusText || this.orderInfo.deliveryStatus;
        order.documentTime = order.documentTime || order.documentDate || this.orderInfo.documentTime;
        order.supplierContractTime = this.getContractUploadTime(order.contractFiles);
        order.customerContractTime = this.getContractUploadTime(order.backContractFiles);

        this.orderInfo = {
          ...this.orderInfo,
          ...order
        };
        this.maiIds = this.getFileIds(this.orderInfo.contractFiles);
        this.ids = this.getFileIds(this.orderInfo.backContractFiles);
        this.sellerContractIds = this.getFileIds(this.orderInfo.contractFiles);
        this.buyerContractIds = this.getFileIds(this.orderInfo.backContractFiles);
        this.total = convertCurrency(this.orderInfo.totalAmount || 0);
        this.setProductList(order.documentItemResultVOList || []);
        this.setShipmentInfo(order.purchaseShipResultVOList || []);
        if (order.sellerEnterpriseId && this.sellerEnterpriseLoadedId !== order.sellerEnterpriseId) {
          this.sellerEnterpriseLoadedId = order.sellerEnterpriseId;
          this.getQy(order.sellerEnterpriseId, 'seller');
        }
        if (order.buyerEnterpriseId) {
          this.getQy(order.buyerEnterpriseId, 'buyer');
        }
      });
    },
    setProductList(list) {
      if (!list.length) return;
      this.productList = list.map(item => {
        const quantity = item.purchaseQty || item.quantity || 0;
        const price = item.purchasePrice || item.salePrice || 0;
        return {
          ...item,
          brandName: item.brandName || '品牌名',
          productName: item.productName,
          orderNo: item.articleNo || item.orderNo || item.skuNumber || '',
          model: item.seriesName || item.model || item.skuNumber || '',
          marketPrice: item.marketPrice || item.referencePrice || '-',
          channel: item.channel || '-',
          channelType: item.channelType || 'self',
          salePrice: price,
          quantity,
          total: item.totalAmount || item.total || 0,
          deliveryTime: item.deliveryTime || item.deliveryCycle || '-',
          isShipped: !!item.shipQty
        };
      });
      this.orderSummary = {
        ...this.orderSummary,
        productTypes: list.length,
        totalQuantity: this.totalNum,
        remark: this.orderInfo.remarks || this.orderInfo.remark || '-',
        orderAmount: this.formatMoney(this.orderInfo.totalAmount),
        productTotal: this.formatMoney(this.orderInfo.totalAmount),
        shippingFee: this.formatMoney(this.orderInfo.freightAmount),
        serviceFee: this.formatMoney(this.orderInfo.serviceAmount),
        totalAmount: this.formatMoney(this.orderInfo.totalAmount)
      };
    },
    setShipmentInfo(list) {
      if (!list.length) {
        this.currentWarehouseTab = 0;
        this.warehouseTabs = [];
        this.warehouseData = [];
        this.warehouseProducts = [];
        this.deliveryProgress = {
          stockTime: '',
          warehouses: []
        };
        return;
      }
      this.warehouseTabs = list.map((item, index) => `出库单${index + 1}`);
      this.warehouseData = list.map((item, index) => ({
        shipRecordId: this.getShipRecordId(item),
        trackingNo: item.documentNumber || item.courierNumber || '',
        city: [item.province, item.city, item.district].filter(Boolean).join('-') || this.warehouseData[index]?.city || '',
        timeline: [
          { time: item.createTime || item.shipTime || '', text: '出库单已生成' },
          { time: item.shipTime || '', text: item.undoFlag === '1' ? '发货单已作废' : '订单已发货' },
          item.isReceipt === '1' ? { time: item.receiptTime || '', text: '订单已签收' } : null
        ].filter(Boolean),
        logisticsCompany: this.getType('courierCompany', item.courierCompany) || item.courierCompany || '',
        logisticsNo: item.courierNumber || '',
        packageTimeline: []
      }));
      this.warehouseProducts = list[this.currentWarehouseTab]?.shipItemResultList?.map(item => ({
        productName: item.productName,
        orderNo: item.articleNo || item.skuNumber || '',
        model: item.seriesName || item.skuNumber || '',
        quantity: item.shipQty || item.purchaseQty || 0
      })) || [];
      this.deliveryProgress = {
        stockTime: list[0].createTime || list[0].shipTime || '',
        warehouses: list.map((item, index) => ({
          name: `出库单${index + 1}`,
          time: item.shipTime || item.createTime || '',
          steps: [
            { label: '出库单', time: item.createTime || '' },
            { label: item.undoFlag === '1' ? '已作废' : '发货', time: item.shipTime || '' },
            { label: item.isReceipt === '1' ? '签收' : '待签收', time: item.receiptTime || '' }
          ]
        }))
      };
      this.getLogistics(list[0]);
    },
    getDetails() {
      if (!this.$route.query.inquiryId) return;
      this.inquirySellerInfo({
        inquiryId: this.$route.query.inquiryId
      }).then(res => {
        const { code, data } = res.data;
        if (code !== '0' || !data || !data.inquiryRequestVO) return;
        const request = data.inquiryRequestVO;
        request.priceUnit = this.getType('moneys', request.priceUnit);
        request.projectFile = this.safeParseFiles(request.projectFile);
        request.file = this.safeParseFiles(request.file);
        request.documentText = this.documentState[request.documentState];
        request.paymentType = this.getType('paymentTypes', request.paymentType);
        request.projectState = request.projectState ? this.getType('projectState', request.projectState) : '';
        this.info = data;
        this.loadBuyerReceiverInfo(request.buyerId);
        this.loadBuyerInvoiceInfo(request.buyerId);
      });
    },
    getLogistics(row) {
      if (!row || !row.courierNumber) return;
      this.purchaseGetExpress({
        courierNumber: row.courierNumber || '',
        courierCompany: row.courierCompany || '',
        courierPhone: row.courierCompany === 'shunfeng' ? row.courierPhone : undefined
      }).then(res => {
        const { code, data } = res.data;
        if (code !== '0') return;
        if (data.status === '200') {
          const packageTimeline = (data.data || []).map(item => ({
            time: item.time || item.ftime || '',
            text: item.context || item.text || ''
          }));
          this.warehouseData[this.currentWarehouseTab] = {
            ...this.currentWarehouseData,
            packageTimeline
          };
        } else {
          ElMessage.error(data.message);
        }
      });
    },
    getReceiverAddressText(data = {}) {
      return [data.province, data.city, data.district, data.receiveAddress || data.address]
        .filter(Boolean)
        .join('');
    },
    copyCardText(text) {
      const copyValue = String(text || '').trim();
      if (!copyValue || copyValue.replace(/[-\s:：]/g, '') === '') {
        ElMessage.warning('当前没有可复制的信息');
        return;
      }
      copyText(copyValue);
    },
    copyReceiverInfo() {
      this.copyCardText([
        `收货人: ${this.receiverInfo.name || '-'}`,
        `地址: ${this.receiverInfo.address || '-'}`,
        `电话: ${this.receiverInfo.phone || '-'}`
      ].join('\n'));
    },
    copyInvoiceReceiverInfo() {
      this.copyCardText([
        `收票人: ${this.invoiceReceiverInfo.name || '-'}`,
        `收票邮箱: ${this.invoiceReceiverInfo.email || '-'}`,
        `电话: ${this.invoiceReceiverInfo.phone || '-'}`
      ].join('\n'));
    },
    copyInvoiceInfo() {
      this.copyCardText([
        `公司名称: ${this.invoiceInfo.companyName || '-'}`,
        `税务登记证号: ${this.invoiceInfo.taxNo || '-'}`,
        `公司开户行名称: ${this.invoiceInfo.bankName || '-'}`,
        `公司开户行账号: ${this.invoiceInfo.bankAccount || '-'}`,
        `注册场所地址: ${this.invoiceInfo.address || '-'}`,
        `注册固定电话: ${this.invoiceInfo.phone || '-'}`
      ].join('\n'));
    },
    pickDefaultReceiverAddress(list = []) {
      if (!Array.isArray(list) || !list.length) return null;
      return list.find(item => item && item.defaultFlag === '1') || list[0] || null;
    },
    applyReceiverAddress(data = {}) {
      if (!data) return;
      this.formValues1 = {
        consigneeName: data.consigneeName || null,
        consigneePhone: data.consigneePhone || null,
        area: [data.province, data.city, data.district].filter(Boolean),
        receiveAddress: data.receiveAddress || data.address || null
      };
      this.receiverInfo = {
        ...this.receiverInfo,
        name: data.consigneeName || this.receiverInfo.name,
        address: this.getReceiverAddressText(data) || this.receiverInfo.address,
        phone: data.consigneePhone || this.receiverInfo.phone
      };
      this.invoiceReceiverInfo = {
        ...this.invoiceReceiverInfo,
        name: data.consigneeName || this.invoiceReceiverInfo.name,
        email: data.email || this.invoiceReceiverInfo.email,
        phone: data.consigneePhone || this.invoiceReceiverInfo.phone
      };
    },
    async loadBuyerReceiverInfo(buyerId) {
      if (!buyerId) return null;
      const listRes = await this.userConsigneeList(buyerId).catch(() => null);
      const { code, data = [] } = listRes?.data || {};
      const enterpriseAddress = code === '0' ? this.pickDefaultReceiverAddress(Array.isArray(data) ? data : []) : null;
      if (enterpriseAddress) {
        this.applyReceiverAddress(enterpriseAddress);
        return enterpriseAddress;
      }
      return null;
    },
    async loadBuyerInvoiceInfo(buyerId) {
      if (!buyerId) return null;
      const invoiceRes = await this.getUserInvoiceUserId({ userId: buyerId }).catch(() => null);
      const { code, data = {} } = invoiceRes?.data || {};
      if (code !== '0') return null;
      this.invoiceInfo = {
        ...this.invoiceInfo,
        companyName: data.invoiceHead || '',
        taxNo: data.taxpayerCode || '',
        bankName: data.bankName || '',
        bankAccount: data.bankAccount || '',
        address: data.address || '',
        phone: data.invoicePhone || '',
        type: data.invoiceType || this.invoiceInfo.type || ''
      };
      return data;
    },
    getInvoiceInfo() {
      if (!this.$route.query.id) return;
      this.fetchInvoiceInfo(this.$route.query.id).then(res => {
        const { code, data } = res.data;
        if (code !== '0') return;
        const invoiceFiles = this.safeParseFiles(
          data?.invoiceFiles || data?.invoiceFile || data?.files || data?.file
        );
        this.invoiceDetailRecord = data && data.id ? { ...data, invoiceFiles } : {};
        this.invoiceInfo = {
          ...this.invoiceInfo,
          invoiceFiles
        };
        this.pendingInvoiceFiles = [...invoiceFiles];
        this.invoiceFileIds = this.getFileIds(invoiceFiles);
        this.invoicePreviewIndex = 0;
      });
    },
    getCollectionRecords() {
      if (!this.$route.query.id) return;
      this.purchaseCollectionList({
        documentId: this.$route.query.id
      }).then(res => {
        const { code, data } = res.data;
        if (code !== '0') return;
        this.collectionRecords = this.normalizeRows(data).filter(item => item.undoFlag !== '1');
        this.paymentList = this.collectionRecords.map((item, index) => ({
          label: `收款${index + 1}`,
          amount: this.formatMoney(item.paidAmount),
          time: item.collectionTime || '',
          note: item.remarks || ''
        }));
      });
    },
    handleModifyPayVoucher() {
      this.payActionExpanded = true;
    },
    collection() {
      this.collectionShow = true;
    },
    handlePayVoucherCardClick() {
      if (this.orderInfo.payFiles && this.orderInfo.payFiles.length) {
        this.openImagePreview(this.orderInfo.payFiles, 0, 'pay');
        return;
      }
      this.collection();
    },
    goRecord() {
      this.showCollectionRecord = true;
    },
    sendGoods() {
      this.sendGoogdShow = true;
    },
    sendSuccess() {
      this.activeSg = 0;
      this.currentWarehouseTab = 0;
      this.loadOrderDetails();
    },
    confirmPayment(ids) {
      this.purchaseUpdatePayment({
        documentId: this.$route.query.id,
        payFiles: ids
      }).then(res => {
        const { code } = res.data;
        if (code === '0') {
          ElMessage.success('提交成功');
          this.getOrderInfo();
          this.getCollectionRecords();
        }
      });
    },
    removeGoods(row) {
      this.purchaseShipUndo({ id: row.id }).then(res => {
        if (res && res.status === 200) {
          this.getOrderInfo();
          ElMessage.success('作废成功');
        } else {
          ElMessage.error('作废失败');
        }
      });
    },
    getShipRecordId(row) {
      if (!row) return '';
      return row.id || row.shipId || row.purchaseShipId || '';
    },
    showInvoiceUploader() {
      this.invoiceEditing = true;
      this.pendingInvoiceFiles = [...(this.invoiceInfo.invoiceFiles || [])];
      this.invoiceFileIds = this.getFileIds(this.pendingInvoiceFiles);
      this.invoiceUploadKey += 1;
    },
    switchInvoicePreview(direction) {
      const total = this.invoiceDisplayFiles.length;
      if (!total) return;
      this.invoicePreviewIndex = (this.safeInvoicePreviewIndex + direction + total) % total;
    },
    async buildInvoiceFilePayload(fileIds = []) {
      const buyerId = this.info?.inquiryRequestVO?.buyerId;
      const invoiceData = (await this.loadBuyerInvoiceInfo(buyerId)) || {};
      const consigneeData =
        (await this.loadBuyerReceiverInfo(buyerId)) || {};
      const currentDetail = this.invoiceDetailRecord || {};
      const currentReceiver = this.invoiceReceiverInfo || {};
      const fallbackAddress = currentDetail.receiveAddress || currentDetail.address || '';
      return {
        documentId: this.$route.query.id,
        invoiceHead: invoiceData.invoiceHead || currentDetail.invoiceHead || this.invoiceInfo.companyName || '',
        taxpayerCode: invoiceData.taxpayerCode || currentDetail.taxpayerCode || this.invoiceInfo.taxNo || '',
        bankName: invoiceData.bankName || currentDetail.bankName || this.invoiceInfo.bankName || '',
        bankAccount: invoiceData.bankAccount || currentDetail.bankAccount || this.invoiceInfo.bankAccount || '',
        address: invoiceData.address || currentDetail.address || this.invoiceInfo.address || '',
        invoicePhone: invoiceData.invoicePhone || currentDetail.invoicePhone || this.invoiceInfo.phone || '',
        invoiceType: invoiceData.invoiceType || currentDetail.invoiceType || this.invoiceInfo.type || '',
        consigneeName: consigneeData.consigneeName || currentDetail.consigneeName || currentReceiver.name || '',
        province: consigneeData.province || currentDetail.province || '',
        city: consigneeData.city || currentDetail.city || '',
        district: consigneeData.district || currentDetail.district || '',
        consigneePhone: consigneeData.consigneePhone || currentDetail.consigneePhone || currentReceiver.phone || '',
        receiveAddress: consigneeData.receiveAddress || consigneeData.address || fallbackAddress,
        invoiceFileIds: fileIds
      };
    },
    async saveInvoiceFiles(fileIds = this.invoiceFileIds) {
      const payload = await this.buildInvoiceFilePayload(fileIds);
      return this.invoiceCreateWithAttachment(payload).then(res => {
        const { code } = res.data;
        if (code === '0') {
          this.getInvoiceInfo();
          ElMessage.success('发票已更新');
        }
      });
    },
    async handleInvoiceUploadSuccess(fileInfo, fileList) {
      this.pendingInvoiceFiles = [...fileList];
      this.invoiceFileIds = this.getFileIds(fileList);
      await this.saveInvoiceFiles(this.invoiceFileIds);
    },
    async handleInvoiceUploadDelete(fileList) {
      this.pendingInvoiceFiles = [...fileList];
      this.invoiceFileIds = this.getFileIds(fileList);
      await this.saveInvoiceFiles(this.invoiceFileIds);
    },
    async removeInvoiceFile(index) {
      const nextFiles = this.pendingInvoiceFiles.filter((_, fileIndex) => fileIndex !== index);
      const nextIds = this.getFileIds(nextFiles);
      this.pendingInvoiceFiles = nextFiles;
      this.invoiceFileIds = nextIds;
      if (this.invoicePreviewIndex >= nextFiles.length) {
        this.invoicePreviewIndex = Math.max(nextFiles.length - 1, 0);
      }
      await this.saveInvoiceFiles(nextIds);
    },
    downloadInvoice() {
      if (!this.invoiceDisplayFiles.length) return;
      downLoadFile(this.invoiceDisplayFiles[this.safeInvoicePreviewIndex].url);
    },
    openReceiptDialog(row = this.currentShipRecord) {
      const shipRecordId = this.currentShipRecordId || this.getShipRecordId(row);
      if (!shipRecordId) {
        ElMessage.warning('暂无可上传的收货记录');
        return;
      }
      this.currentReceiptShipId = shipRecordId;
      this.receiptDialogShow = true;
    },
    handleShippingStatusImageClick(index = 0) {
      if (!this.shippingStatusDisplayFiles.length) return;
      this.openImagePreview(this.shippingStatusDisplayFiles, index, 'shipping');
    },
    switchShippingStatusPreview(direction) {
      const total = this.shippingStatusDisplayFiles.length;
      if (!total) return;
      this.shippingStatusPreviewIndex = (this.safeShippingStatusPreviewIndex + direction + total) % total;
    },
    getQy(id, type) {
      return this.getEnterprise(id).then(res => {
        const { code, data } = res.data;
        if (code === '0') {
          this[type] = data;
          if (type === 'buyer' && data.sealFlies) {
            const sealFiles = this.safeParseFiles(data.sealFlies);
            if (sealFiles.length && sealFiles[0].url) {
              this.getBas64(sealFiles[0].url).then(img => {
                this.img = img;
              });
            }
          }
          return data;
        }
        return null;
      });
    },
    getFiles(payFiles) {
      return (payFiles || []).map(file => file.url);
    },
    getFileIds(files) {
      return (files || []).map(file => this.getUploadFileId(file) || file.id).filter(Boolean);
    },
    getContractUploadTime(files) {
      const list = (files || []).filter(file => file && file.uploadTime);
      if (!list.length) return '';
      return list[list.length - 1].uploadTime;
    },
    previewContract() {
      this.$router.push({
        path: '/contract',
        query: {
          id: this.$route.query.id
        }
      });
    },
    showCollectionQrCode() {
      if (!this.sellerCollectionQrCodeFile) {
        ElMessage.warning('卖方暂未维护收款码');
        return;
      }
      this.openImagePreview(this.sellerCollectionQrCodeFiles, 0, 'collectionQrCode');
    },
    async handleCollectionQrCodeToggle() {
      if (this.collectionQrCodeEnabled) {
        await this.updateCollectionQrCodeStatus('0');
        return;
      }
      if (this.sellerCollectionQrCodeFile) {
        await this.updateCollectionQrCodeStatus('1');
        return;
      }
      try {
        await ElMessageBox.confirm('您还未上传收款码，是否立即上传？', '提示', {
          confirmButtonText: '去上传',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.$router.push({
          path: '/companyInfo/index',
          query: {
            enableCollectionQrCodeForOrder: this.orderInfo.id || this.$route.query.id
          }
        });
      } catch (error) {
        // 用户取消上传，无需处理。
      }
    },
    async updateCollectionQrCodeStatus(collectionQrCodeEnabled) {
      const documentId = this.orderInfo.id || this.$route.query.id;
      if (!documentId) return;
      const res = await this.purchaseUpdateCollectionQrCodeStatus({
        documentId,
        collectionQrCodeEnabled
      });
      if (res?.data?.code !== '0') return;
      this.orderInfo.collectionQrCodeEnabled = collectionQrCodeEnabled;
      ElMessage.success(collectionQrCodeEnabled === '1' ? '收款码已启用' : '收款码已关闭');
    },
    getCachedSellerInfo() {
      const info = this.info || {};
      const request = info.inquiryRequestVO || {};
      return [
        this.seller,
        info.sellerEnterpriseInfo,
        info.sellerInfo,
        info.enterpriseInfo,
        info.enterprise,
        request.sellerEnterpriseInfo,
        request.sellerInfo,
        request
      ].find(item => item && item.collectionQrCode) || {};
    },
    openBuyerContractAutoStamp() {
      const sellerContractFiles = this.sellerContractDisplayFiles;
      if (!sellerContractFiles.length) {
        ElMessage.warning('请先上传卖方合同后再盖章');
        return;
      }
      this.openImagePreview(sellerContractFiles, 0, 'seller', 'buyer');
    },
    openImagePreview(files = [], index = 0, type = '', saveType = type) {
      const list = this.getFiles(files).filter(Boolean);
      if (!list.length) return;
      this.imagePreviewList = list;
      this.imagePreviewIndex = Math.min(Math.max(index, 0), list.length - 1);
      this.imagePreviewType = type;
      this.imagePreviewSaveType = saveType;
      this.imagePreviewStamped = false;
      this.imagePreviewSeamStamped = false;
      this.imagePreviewUploading = false;
      this.imagePreviewSealPosition = null;
      this.imagePreviewSealWidth = 210;
      this.imagePreviewVisible = true;
      this.prepareImagePreviewCaptureUrl();
    },
    closeImagePreview() {
      this.imagePreviewVisible = false;
      this.imagePreviewList = [];
      this.imagePreviewIndex = 0;
      this.imagePreviewType = '';
      this.imagePreviewSaveType = '';
      this.imagePreviewStamped = false;
      this.imagePreviewSeamStamped = false;
      this.imagePreviewUploading = false;
      this.imagePreviewCaptureUrl = '';
      this.imagePreviewSealPosition = null;
      this.imagePreviewSealWidth = 210;
      this.stopImagePreviewSealDrag();
    },
    switchImagePreview(direction) {
      const total = this.imagePreviewList.length;
      if (!total) return;
      this.imagePreviewIndex = (this.imagePreviewIndex + direction + total) % total;
      this.imagePreviewStamped = false;
      this.imagePreviewSeamStamped = false;
      this.imagePreviewSealPosition = null;
      this.imagePreviewSealWidth = 210;
      this.prepareImagePreviewCaptureUrl();
    },
    prepareImagePreviewCaptureUrl() {
      const url = this.currentImagePreviewUrl;
      this.imagePreviewCaptureUrl = url;
      if (!url || !this.canStampImagePreview || !url.startsWith('http')) return;
      this.getBas64(url).then(img => {
        if (this.currentImagePreviewUrl === url) {
          this.imagePreviewCaptureUrl = img;
        }
      });
    },
    stampImagePreview() {
      if (!this.ensureContractsEditable()) return;
      if (!this.img) {
        this.promptUploadContractSeal();
        return;
      }
      if (!this.imagePreviewStamped) {
        this.imagePreviewSealPosition = null;
        this.imagePreviewSealWidth = 210;
      }
      this.imagePreviewStamped = true;
    },
    seamStampImagePreview() {
      if (!this.ensureContractsEditable()) return;
      if (!this.img) {
        this.promptUploadContractSeal();
        return;
      }
      this.imagePreviewSeamStamped = true;
    },
    promptUploadContractSeal() {
      this.closeImagePreview();
      this.$nextTick(() => {
        ElMessageBox.confirm('请先维护企业合同章后再盖章，是否前往上传？', '提示', {
          confirmButtonText: '去上传',
          cancelButtonText: '暂不上传',
          type: 'warning'
        }).then(() => {
          this.$router.push('/companyInfo/index');
        }).catch(() => {});
      });
    },
    resizeImagePreviewSeal(offset) {
      const nextWidth = Math.min(Math.max(this.imagePreviewSealWidth + offset, 80), 360);
      if (nextWidth === this.imagePreviewSealWidth) return;
      const capture = this.$refs.orderStampCapture;
      const seal = this.$refs.orderStampSeal;
      if (capture && seal && this.imagePreviewSealPosition) {
        const captureRect = capture.getBoundingClientRect();
        const sealRect = seal.getBoundingClientRect();
        const nextHeight = sealRect.height * nextWidth / sealRect.width;
        this.imagePreviewSealPosition = {
          x: Math.min(this.imagePreviewSealPosition.x, Math.max(captureRect.width - nextWidth, 0)),
          y: Math.min(this.imagePreviewSealPosition.y, Math.max(captureRect.height - nextHeight, 0))
        };
      }
      this.imagePreviewSealWidth = nextWidth;
    },
    startImagePreviewSealDrag(event) {
      const capture = this.$refs.orderStampCapture;
      const seal = this.$refs.orderStampSeal;
      if (!capture || !seal) return;
      const captureRect = capture.getBoundingClientRect();
      const sealRect = seal.getBoundingClientRect();
      this.imagePreviewSealPosition = {
        x: sealRect.left - captureRect.left,
        y: sealRect.top - captureRect.top
      };
      this.imagePreviewSealDragOffset = {
        x: event.clientX - sealRect.left,
        y: event.clientY - sealRect.top
      };
      this.imagePreviewSealDragging = true;
      window.addEventListener('pointermove', this.moveImagePreviewSeal);
      window.addEventListener('pointerup', this.stopImagePreviewSealDrag);
    },
    moveImagePreviewSeal(event) {
      const capture = this.$refs.orderStampCapture;
      const seal = this.$refs.orderStampSeal;
      const offset = this.imagePreviewSealDragOffset;
      if (!capture || !seal || !offset) return;
      const captureRect = capture.getBoundingClientRect();
      const sealRect = seal.getBoundingClientRect();
      this.imagePreviewSealPosition = {
        x: Math.min(Math.max(event.clientX - captureRect.left - offset.x, 0), Math.max(captureRect.width - sealRect.width, 0)),
        y: Math.min(Math.max(event.clientY - captureRect.top - offset.y, 0), Math.max(captureRect.height - sealRect.height, 0))
      };
    },
    stopImagePreviewSealDrag() {
      this.imagePreviewSealDragging = false;
      this.imagePreviewSealDragOffset = null;
      window.removeEventListener('pointermove', this.moveImagePreviewSeal);
      window.removeEventListener('pointerup', this.stopImagePreviewSealDrag);
    },
    downloadImagePreview() {
      if (!this.currentImagePreviewUrl) return;
      downLoadFile(this.currentImagePreviewUrl);
    },
    confirmImagePreviewStamp() {
      if (!this.ensureContractsEditable()) return;
      if (!this.hasImagePreviewStamp) {
        ElMessage.warning('请先点击盖章或骑缝章');
        return;
      }
      const capture = this.$refs.orderStampCapture;
      if (!capture) return;
      const sourceFiles = this.getContractFilesByType(this.imagePreviewType);
      const sourceFile = sourceFiles[this.imagePreviewIndex];
      this.imagePreviewUploading = true;
      this.$nextTick(() => {
        html2Canvas(capture, {
          allowTaint: true,
          useCORS: true,
          backgroundColor: '#ffffff'
        }).then(canvas => {
          canvas.toBlob(blob => {
            if (!blob) {
              this.imagePreviewUploading = false;
              return;
            }
            const file = new File([blob], '货物购销合同.png', { type: 'image/png' });
            this.uploadStampedContract(file, {
              sourceType: this.imagePreviewType,
              saveType: this.imagePreviewSaveType,
              index: this.imagePreviewIndex,
              sourceFileId: this.getUploadFileId(sourceFile) || sourceFile?.id
            });
          }, 'image/png');
        }).catch(() => {
          this.imagePreviewUploading = false;
        });
      });
    },
    uploadStampedContract(file, target) {
      if (!this.ensureContractsEditable()) return;
      const formData = new FormData();
      formData.append('file', file);
      return request.post(`${api.uploadFile}?fileType=CUSTOMER`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        const stampedFile = res?.data?.data;
        if (!stampedFile || !this.getUploadFileId(stampedFile)) {
          throw new Error('盖章文件上传失败');
        }
        return this.replaceStampedContractFile(stampedFile, target);
      }).then(() => {
        ElMessage.success(target.sourceType === target.saveType ? '盖章合同已覆盖原附件' : '盖章合同已保存至买方合同');
        this.closeImagePreview();
        this.getOrderInfo();
      }).catch(() => {
        ElMessage.error('盖章合同保存失败，请重试');
      }).finally(() => {
        this.imagePreviewUploading = false;
      });
    },
    replaceStampedContractFile(stampedFile, target = {}) {
      const { sourceType, saveType, index, sourceFileId } = target;
      const isSellerContract = saveType === 'seller';
      const originalFiles = isSellerContract
        ? (this.orderInfo.contractFiles || [])
        : (this.orderInfo.backContractFiles || []);
      if (!['seller', 'buyer'].includes(sourceType) || !['seller', 'buyer'].includes(saveType)) {
        return Promise.reject(new Error('未找到待保存的合同附件'));
      }

      const files = [...originalFiles];
      const replacementIndex = sourceType === saveType
        ? index
        : files.findIndex(file => (this.getUploadFileId(file) || file.id) === sourceFileId);
      if (replacementIndex >= 0) {
        files.splice(replacementIndex, 1, stampedFile);
      } else {
        files.push(stampedFile);
      }
      const fileIds = this.getFileIds(files);
      const saveRequest = isSellerContract
        ? this.purchaseUpdateContractFile({
          documentId: this.$route.query.id,
          contractFileIds: fileIds
        })
        : this.purchaseUpdateBackContractFile({
          documentId: this.$route.query.id,
          backContractFileIds: fileIds,
          backContractUploadUserId: this.currentUserId,
          backContractUploadUserType: this.buyerContractUploaderRole
        });

      return saveRequest.then(res => {
        if (res?.data?.code !== '0') {
          return Promise.reject(new Error('合同附件更新失败'));
        }
        if (isSellerContract) {
          this.orderInfo.contractFiles = files;
          this.sellerContractIds = fileIds;
          this.maiIds = [...fileIds];
        } else {
          this.orderInfo.backContractFiles = files;
          this.buyerContractIds = fileIds;
          this.ids = [...fileIds];
        }
      });
    },
    getContractFilesByType(type) {
      if (type === 'seller') return this.orderInfo.contractFiles || [];
      if (type === 'buyer') return this.orderInfo.backContractFiles || [];
      return [];
    },
    triggerBuyerContractUpload() {
      const uploadTrigger = this.$refs.buyerContractUpload?.$el?.querySelector('.el-upload');
      if (uploadTrigger) {
        uploadTrigger.click();
      }
    },
    getBas64(url, outputFormat = 'image/png') {
      return new Promise((resolve) => {
        let canvas = document.createElement('CANVAS');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = function () {
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL(outputFormat);
          canvas = null;
          resolve(dataURL);
        };
        img.src = `${url}?t=${new Date().valueOf()}`;
      });
    },
    getFileListIds(fileList) {
      return (fileList || []).map(file => {
        return this.getUploadFileId(file);
      }).filter(Boolean);
    },
    getUploadFileId(file) {
      if (!file) return '';
      if (file.fileId) return file.fileId;
      if (file.data && file.data.fileId) return file.data.fileId;
      if (file.response && file.response.fileId) return file.response.fileId;
      if (file.response && file.response.data && file.response.data.fileId) return file.response.data.fileId;
      if (file.response && file.response.data && file.response.data.data && file.response.data.data.fileId) {
        return file.response.data.data.fileId;
      }
      return '';
    },
    getUploadFileInfo(file) {
      if (!file) return null;
      if (file.fileId || file.url) return file;
      if (file.data && (file.data.fileId || file.data.url)) return file.data;
      if (file.response && file.response.data && (file.response.data.fileId || file.response.data.url)) return file.response.data;
      if (file.response && file.response.data && file.response.data.data) return file.response.data.data;
      return null;
    },
    getUploadFileInfos(fileList) {
      const seen = new Set();
      return (fileList || []).reduce((list, file, index) => {
        const info = this.getUploadFileInfo(file);
        if (!info) return list;
        const key = info.fileId || info.id || info.url || index;
        if (seen.has(key)) return list;
        seen.add(key);
        list.push(info);
        return list;
      }, []);
    },
    appendPendingContractFile(currentFiles = [], currentIds = [], fileInfo) {
      const info = this.getUploadFileInfo(fileInfo);
      const nextFiles = [...currentFiles];
      const nextIds = [...currentIds];
      if (!info) {
        return { files: nextFiles, ids: nextIds };
      }
      const key = info.fileId || info.id || info.url;
      if (!nextFiles.some(item => (item.fileId || item.id || item.url) === key)) {
        nextFiles.push(info);
      }
      const fileId = this.getUploadFileId(info) || info.fileId || info.id;
      if (fileId && !nextIds.includes(fileId)) {
        nextIds.push(fileId);
      }
      return {
        files: nextFiles,
        ids: nextIds
      };
    },
    getContractViewport(refName) {
      const target = this.$refs[refName];
      return Array.isArray(target) ? target[0] : target;
    },
    resetContractScroll(refName) {
      const viewport = this.getContractViewport(refName);
      if (viewport) {
        viewport.scrollLeft = 0;
      }
    },
    scrollContractList(refName, direction) {
      const viewport = this.getContractViewport(refName);
      if (!viewport) return;
      const card = viewport.querySelector('.contract-preview-card, .el-upload-list__item');
      const step = card ? card.offsetWidth + 12 : 100;
      viewport.scrollBy({
        left: direction * step * this.contractSliderVisibleCount,
        behavior: 'smooth'
      });
    },
    switchContractPreview(type, direction) {
      if (type === 'seller') {
        const total = this.sellerContractDisplayFiles.length;
        if (!total) return;
        this.sellerPreviewIndex = (this.safeSellerPreviewIndex + direction + total) % total;
        return;
      }
      const total = this.buyerContractDisplayFiles.length;
      if (!total) return;
      this.buyerPreviewIndex = (this.safeBuyerPreviewIndex + direction + total) % total;
    },
    getLatestUploadId(fileInfo, fileList) {
      const fileId = this.getUploadFileId(fileInfo);
      if (fileId) return [fileId];
      const ids = this.getFileListIds(fileList);
      return ids.length ? [ids[ids.length - 1]] : [];
    },
    resolveContractIds(fileInfo, fileList, currentIds = []) {
      const ids = this.getFileListIds(fileList);
      if (ids.length) return ids;
      const latestIds = this.getLatestUploadId(fileInfo, fileList);
      if (latestIds.length) return latestIds;
      return [...currentIds];
    },
    buyerContractUploadSuccess(fileInfo, fileList) {
      if (!this.ensureContractsEditable()) return;
      const next = this.appendPendingContractFile(
        this.pendingBuyerContractFiles,
        this.pendingBuyerContractIds,
        fileInfo
      );
      this.pendingBuyerContractIds = next.ids;
      this.buyerContractIds = [...next.ids];
      this.pendingBuyerContractFiles = next.files;
      this.ids = [...next.ids];
      this.buyerPreviewIndex = Math.max(next.files.length - 1, 0);
    },
    buyerContractDelete(fileList) {
      if (!this.ensureContractsEditable()) return;
      const ids = this.getFileListIds(fileList);
      this.pendingBuyerContractIds = ids;
      this.buyerContractIds = [...ids];
      this.pendingBuyerContractFiles = this.getUploadFileInfos(fileList);
    },
    removeBuyerContractFile(index) {
      if (!this.ensureContractsEditable()) return;
      const nextFiles = this.pendingBuyerContractFiles.filter((_, fileIndex) => fileIndex !== index);
      const nextIds = this.getFileIds(nextFiles);
      this.pendingBuyerContractFiles = nextFiles;
      this.pendingBuyerContractIds = nextIds;
      this.buyerContractIds = [...nextIds];
      this.ids = [...nextIds];
      if (this.buyerPreviewIndex >= nextFiles.length) {
        this.buyerPreviewIndex = Math.max(nextFiles.length - 1, 0);
      }
    },
    editBuyerContract() {
      if (!this.ensureContractsEditable()) return;
      this.buyerContractEditing = true;
      this.buyerPreviewIndex = 0;
      this.pendingBuyerContractIds = [...this.buyerContractIds];
      this.pendingBuyerContractFiles = [...(this.orderInfo.backContractFiles || [])];
      this.ids = [...this.pendingBuyerContractIds];
      this.buyerUploadKey += 1;
      this.$nextTick(() => {
        this.resetContractScroll('buyerEditViewport');
      });
    },
    confirmBuyerContract() {
      if (!this.ensureContractsEditable()) return;
      const ids = [...this.pendingBuyerContractIds];
      this.buyerContractChange(ids);
    },
    buyerContractChange(ids = this.buyerContractIds) {
      if (!this.ensureContractsEditable()) return;
      this.buyerContractIds = [...ids];
      this.$nextTick(() => {
        this.purchaseUpdateBackContractFile({
          documentId: this.$route.query.id,
          backContractFileIds: this.buyerContractIds,
          backContractUploadUserId: this.currentUserId,
          backContractUploadUserType: this.buyerContractUploaderRole
        }).then(res => {
          const { code } = res.data;
          if (code === '0') {
            ElMessage.success('操作成功');
            this.buyerContractEditing = false;
            this.pendingBuyerContractIds = [];
            this.pendingBuyerContractFiles = [];
            this.ids = [];
            this.getOrderInfo();
          }
        });
      });
    },
    sellerContractUploadSuccess(fileInfo, fileList) {
      if (!this.ensureContractsEditable()) return;
      const next = this.appendPendingContractFile(
        this.pendingSellerContractFiles,
        this.pendingSellerContractIds,
        fileInfo
      );
      this.pendingSellerContractIds = next.ids;
      this.sellerContractIds = [...next.ids];
      this.pendingSellerContractFiles = next.files;
      this.maiIds = [...next.ids];
      this.sellerPreviewIndex = Math.max(next.files.length - 1, 0);
    },
    sellerContractDelete(fileList) {
      if (!this.ensureContractsEditable()) return;
      const ids = this.getFileListIds(fileList);
      this.pendingSellerContractIds = ids;
      this.sellerContractIds = [...ids];
      this.pendingSellerContractFiles = this.getUploadFileInfos(fileList);
    },
    removeSellerContractFile(index) {
      if (!this.ensureContractsEditable()) return;
      const nextFiles = this.pendingSellerContractFiles.filter((_, fileIndex) => fileIndex !== index);
      const nextIds = this.getFileIds(nextFiles);
      this.pendingSellerContractFiles = nextFiles;
      this.pendingSellerContractIds = nextIds;
      this.sellerContractIds = [...nextIds];
      this.maiIds = [...nextIds];
      if (this.sellerPreviewIndex >= nextFiles.length) {
        this.sellerPreviewIndex = Math.max(nextFiles.length - 1, 0);
      }
    },
    editSellerContract() {
      if (!this.ensureContractsEditable()) return;
      this.sellerContractEditing = true;
      this.sellerPreviewIndex = 0;
      this.pendingSellerContractIds = [...this.sellerContractIds];
      this.pendingAutoFillBuyerIds = [];
      this.pendingSellerContractFiles = [...(this.orderInfo.contractFiles || [])];
      this.maiIds = [...this.pendingSellerContractIds];
      this.sellerUploadKey += 1;
      this.$nextTick(() => {
        this.resetContractScroll('sellerEditViewport');
      });
    },
    confirmSellerContract() {
      if (!this.ensureContractsEditable()) return;
      const ids = [...this.pendingSellerContractIds];
      this.sellerContractChange(ids);
    },
    sellerContractChange(ids = this.sellerContractIds) {
      if (!this.ensureContractsEditable()) return;
      this.sellerContractIds = [...ids];
      this.$nextTick(() => {
        this.purchaseUpdateContractFile({
          documentId: this.$route.query.id,
          contractFileIds: this.sellerContractIds
        }).then(res => {
          const { code } = res.data;
          if (code === '0') {
            const confirmBuyerRequest = this.pendingAutoFillBuyerIds.length
              ? this.purchaseUpdateBackContractFile({
                documentId: this.$route.query.id,
                backContractFileIds: this.pendingAutoFillBuyerIds
              })
              : Promise.resolve();
            confirmBuyerRequest.then(() => {
              ElMessage.success('操作成功');
              this.sellerContractEditing = false;
              this.pendingSellerContractIds = [];
              this.pendingAutoFillBuyerIds = [];
              this.pendingSellerContractFiles = [];
              this.maiIds = [];
              this.getOrderInfo();
            });
          }
        });
      });
    },
    handleSellerAutoFill(fileInfo) {
      if (!this.ensureContractsEditable()) return;
      if (fileInfo && fileInfo.data && fileInfo.data.fileId) {
        this.pendingAutoFillBuyerIds = [fileInfo.data.fileId];
      }
    },
    contractSuccess(fileInfo, fileList) {
      this.sellerContractUploadSuccess(fileInfo, fileList);
    }
  },
  watch: {
    isFullyPaid(fullyPaid) {
      if (!fullyPaid) return;
      this.sellerContractEditing = false;
      this.buyerContractEditing = false;
      this.pendingSellerContractIds = [];
      this.pendingBuyerContractIds = [];
      this.pendingSellerContractFiles = [];
      this.pendingBuyerContractFiles = [];
      this.pendingAutoFillBuyerIds = [];
      this.maiIds = [];
      this.ids = [];
    },
    currentWarehouseTab(index) {
      const shipList = this.orderInfo.purchaseShipResultVOList || [];
      this.shippingStatusPreviewIndex = 0;
      this.warehouseProducts = shipList[index]?.shipItemResultList?.map(item => ({
        productName: item.productName,
        orderNo: item.articleNo || item.skuNumber || '',
        model: item.seriesName || item.skuNumber || '',
        quantity: item.shipQty || item.purchaseQty || 0
      })) || [];
      this.getLogistics(shipList[index]);
    }
  }
};
</script>

<style scoped lang="less">
.order-details-page {
  background: #f4f4f4;
  min-height: 100vh;
  width: 100%;
}

.order-status-section {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;

  .status-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px 20px 0 20px;

    .status-badge {
      display: flex;
      align-items: center;
      gap: 12px;

      .status-icon {
        width: 28px;
        height: 28px;
      }

      .status-text {
        font-size: 20px;
        font-weight: 600;
        color: #333;
      }
    }
  }

  .order-divider {
    height: 40px;
    margin: 12px 0 0 -40px;
    display: block;
    width: 103%;
  }

  .order-basic-info {
    display: flex;
    margin-bottom: 20px;
    padding: 12px 20px;

    .info-left {
      margin-right: 223px;
    }

    p {
      margin: 4px 0;
      font-size: 14px;
      color: #333;
      line-height: 28px;
    }
  }

  .contract-payment-section {
    display: flex;
    margin-top: 8px;
    padding: 0 16px;
    gap: 20px;

    .section-divider-vertical {
      width: 1px;
      height: 135px;
      align-self: flex-start;
    }
  }

  .process-section {
    display: flex;
    position: relative;
    flex: 1;
  }

  .section-title-vertical {
    width: 56px;
    min-height: 135px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    margin-right: 26px;
    flex-shrink: 0;
    background-size: 64px 143px;

    span {
      font-size: 18px;
      font-weight: 600;
      color: #333;
      line-height: 20px;
    }

    &.contract-title {
      background: url('~@/assets/order/red-bg.png') -3px -4px no-repeat;
      background-size: 64px 143px;
    }

    &.payment-title {
      background: url('~@/assets/order/progress-pay.png') -3px -5px no-repeat;
      background-size: 64px 143px;
    }

    &.delivery-title {
      background: url('~@/assets/order/ship-bg.png') -3px -4px no-repeat;
      background-size: 64px 266px;
      min-height: 258px;
    }
  }

  .process-content {
    flex: 1;
    display: flex;
    gap: 30px;
    align-items: flex-start;
    padding-top: 23px;
  }

  .process-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 150px;

    .item-label {
      font-size: 14px;
      color: #333;
      margin-bottom: 4px;
      margin-left: 24px;
    }

    .item-status-with-arrow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }

    .item-status {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #333;

      .status-icon-sm {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
      }
    }

    .arrow-icon {
      width: 120px;
      height: 12px;
      flex-shrink: 0;
    }

    .item-amount {
      font-size: 12px;
      color: #333;
      margin-left: 28px;
    }

    .item-time {
      font-size: 12px;
      color: #919696;
      margin-left: 28px;
    }

    .item-note {
      font-size: 14px;
      color: #48a09c;
      margin-left: 28px;
      margin-top: 4px;
    }
  }





  .delivery-section {
    margin-top: 20px;
    padding: 20px 20px 20px 20px;
    border-top: 1px solid #f0f0f0;
    display: flex;
    min-height: 258px;

    .section-title-vertical {
      min-height: 258px;
    }

    .delivery-content-wrapper {
      flex: 1;
      display: flex;
      padding-top: 23px;
      position: relative;
    }

    .stock-row {
      display: flex;
      align-items: flex-start;
      margin-bottom: 0;
      position: relative;


    }

    .warehouse-flows {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin-left: 68px;
      margin-top: -10px;
    }

    .delivery-row {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      flex-wrap: nowrap;
    }

    .delivery-node {
      display: flex;
      flex-direction: column;
      gap: 4px;
      min-width: 100px;

      .node-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: #333;
        line-height: 20px;

        .node-icon {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        span {
          line-height: 20px;
        }
      }

      .node-badge {
        background: #e3f1e0;
        border-radius: 2px;
        padding: 6px 12px;
        color: #49b76b;
        font-size: 14px;
        display: inline-block;
        width: fit-content;
      }

      .node-time {
        font-size: 12px;
        color: #919696;
      }
    }

    .connect-arrow {
      width: 120px;
      height: 12px;
      margin-top: 4px;
      flex-shrink: 0;
    }
  }
}

// 买卖合同样式
.contract {
  display: flex;
  gap: 40px;
  margin-top: 20px;
  padding: 20px;
  background-color: #fff;

  .contract-section {
    flex: 1;
    display: flex;
    position: relative;

    .contract-vertical-title {
      width: 56px;
      height: 242px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4px;
      margin-right: 26px;
      flex-shrink: 0;
      background-size: 64px 250px;

      span {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
      }

      &.seller-title {
        background: url('~@/assets/order/seller-bg.png') -3px -4px no-repeat;
        background-size: 64px 250px;
      }

      &.buyer-title {
        background: url('~@/assets/order/buyer.png') -3px -4px no-repeat;
        background-size: 64px 250px;
      }

      &.pay-info-title {
        background: url('~@/assets/order/pay-info.png') -3px -4px no-repeat;
        background-size: 64px 250px;
      }

      &.shipping-status-title {
        background: url('~@/assets/order/shipping-status.png') -3px -4px no-repeat;
        background-size: 64px 250px;
      }

      &.billing-information-title {
        background: url('~@/assets/order/billing-information.png') -3px -4px no-repeat;
        background-size: 64px 250px;
      }
    }

    .contract-vertical-title {
      margin-right: 0;
    }

    .contract-main {
      flex: 1;
      position: relative;
      display: flex;
      align-items: center;
      background: #f7f7f7;
      height: 242px;
      padding-left: 78px;
      padding-top: 20px;
      box-sizing: border-box;


      .contract-actions {
        position: absolute;
        top: 20px;
        right: 20px;
        display: flex;
        gap: 12px;
        z-index: 10;

        button {
          padding: 0 24px;
          border-radius: 4px;
          font-size: 14px;
          cursor: pointer;
          border: 1px solid;
          transition: all 0.3s;
          height: 32px;

          &.btn-modify {
            background: #fff;
            color: #48a09c;
            border-color: #48a09c;

            &:hover {
              background: #f0f9f8;
            }
          }

          &.btn-confirm {
            background: #48a09c;
            color: #fff;
            border-color: #48a09c;

            &:hover {
              background: #3a8a87;
            }

            &:disabled {
              cursor: not-allowed;
              background: #b7d8d6;
              border-color: #b7d8d6;
              color: #ffffff;
            }
          }
        }
      }

      .contract-content {
        display: flex;
        gap: 20px;
        margin-top: 32px;
        display: flex;
        align-items: center;



        .contract-item {
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: flex-start;
          border: 2px dashed #d9d9d9;
          border-radius: 8px;
          background: #fff;
          height: 141px;
          gap: 12px;
          width: 130px;
          position: relative;
          display: flex;
          align-items: center;

          &.contract-item-slider {
            padding: 0 16px;
          }

          .contract-badge {
            padding: 6px 16px;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 500;
            flex-shrink: 0;
            height: fit-content;



            &.customer {
              background: #ff6b6b;
              color: #fff;
            }
          }

          .contract-preview {
            flex: 1;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            overflow: hidden;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;

            .contract-img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }

            .contract-empty {
              font-size: 13px;
              color: #909595;
            }

            .payment-status-box {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 100%;
              height: 100%;
              padding: 20px;
              background: linear-gradient(180deg, #FFF5E6 0%, #FFFFFF 100%);

              .status-warning {
                display: flex;
                align-items: center;
                gap: 12px;
                margin-bottom: 30px;

                .warning-icon {
                  width: 48px;
                  height: 48px;
                  border-radius: 50%;
                  border: 3px solid #FF9933;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  .icon-circle {
                    font-size: 32px;
                    font-weight: bold;
                    color: #FF9933;
                    line-height: 1;
                  }
                }

                .status-text {
                  font-size: 28px;
                  font-weight: 500;
                  color: #FF9933;
                }
              }

              .payment-amount {
                display: flex;
                flex-direction: column;
                gap: 20px;
                width: 100%;

                .amount-item {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;

                  .amount-label {
                    font-size: 16px;
                    color: #999999;
                  }

                  .amount-value {
                    font-size: 18px;
                    color: #666666;
                  }

                  &.total-amount {

                    .amount-label,
                    .amount-value {
                      font-size: 20px;
                      font-weight: 500;
                      color: #333333;
                    }
                  }
                }
              }
            }
          }


          .contract-upload-area {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 130px;
            height: 143px;
            margin: 0 auto;

            .upload-icon {
              width: 20px;
              height: 20px;
              margin-bottom: 8px;
            }

            .upload-text {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #606666;
              line-height: 20px;
              text-align: left;
              font-style: normal;
            }

            .upload-hint {
              font-size: 11px;
              color: #999;
              text-align: center;
              line-height: 16px;
            }
          }

          .contract-uploader {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            box-sizing: border-box;

            :deep(.upload-demo),
            :deep(.el-upload-list),
            :deep(.el-upload-list--picture-card) {
              display: flex;
              align-items: flex-start;
              flex-wrap: nowrap;
              gap: 12px;
              margin: 0;
            }

            :deep(.el-upload),
            :deep(.el-upload--picture-card) {
              width: 88px;
              height: 88px;
              border: none;
              background: transparent;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            :deep(.upload-demo),
            :deep(.el-upload),
            :deep(.el-upload-list--picture-card) {
              width: 100%;
              height: 100%;
            }

            :deep(.el-upload-dragger) {
              width: 100%;
              height: 100%;
              padding: 12px 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: none;
              background: transparent;
              line-height: normal;
            }

            :deep(.el-upload-dragger.is-dragover) {
              background: #e5f3f2;
            }

            :deep(.icon-yunshangchuan) {
              margin-top: 0;
              font-size: 36px;
            }

            :deep(.el-upload__text) {
              margin-top: 8px;
              font-size: 13px;
              line-height: 20px;
            }

            :deep(.el-upload__tip) {
              display: none;
            }

            :deep(.el-upload-list__item) {
              width: 88px;
              height: 88px;
              margin: 0;
              border-radius: 10px;
              overflow: hidden;
              border: 1px solid #e5eceb;
              box-shadow: 0 6px 14px rgba(72, 160, 156, 0.08);
            }
          }

          .contract-slider-area {
            display: flex;
            align-items: center;
            gap: 12px;
            width: 100%;
            min-width: 0;
          }

          .contract-slider-viewport {
            width: 288px;
            max-width: 288px;
            overflow-x: auto;
            overflow-y: hidden;
            scroll-behavior: smooth;
            scrollbar-width: none;
            -ms-overflow-style: none;

            &::-webkit-scrollbar {
              display: none;
            }
          }

          .contract-slider-viewport-upload {
            :deep(.el-upload-list),
            :deep(.el-upload-list--picture-card) {
              flex-wrap: nowrap;
            }
          }

          .slider-nav {
            width: 28px;
            height: 28px;
            border: 1px solid #cfe3e1;
            border-radius: 50%;
            background: #fff;
            color: #48a09c;
            font-size: 18px;
            line-height: 1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            flex-shrink: 0;
            transition: all 0.2s ease;

            &:hover {
              background: #f0f9f8;
              border-color: #48a09c;
            }
          }

          .contract-preview-card {
            position: relative;
          }

          .contract-preview-shell {
            position: relative;
            flex: none;
            width: 160px;
            height: 132px;
            overflow: hidden;
          }

          .contract-empty-text {
            font-size: 13px;
            font-weight: 500;
            color: #333333;
            line-height: 18px;
          }

          .contract-preview-overlay {
            position: absolute;
            inset: 0;
            z-index: 2;
            background: #fff;
          }

          .contract-stage-image {
            width: 100%;
            height: 100%;
            display: block;

            :deep(.el-image__inner) {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          .contract-stage-nav {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 4;
            width: 20px;
            height: 20px;
            border: 1px solid #cfe3e1;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.94);
            color: #48a09c;
            font-size: 14px;
            line-height: 18px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            padding: 0;

            &.contract-stage-nav-prev {
              left: 4px;
            }

            &.contract-stage-nav-next {
              right: 4px;
            }
          }

          .contract-preview-count {
            position: absolute;
            right: 6px;
            bottom: 6px;
            z-index: 4;
            padding: 0 6px;
            height: 18px;
            border-radius: 10px;
            background: rgba(17, 24, 39, 0.6);
            color: #fff;
            font-size: 11px;
            line-height: 18px;
          }

          .contract-delete-btn {
            position: absolute;
            top: 6px;
            right: 6px;
            width: 18px;
            height: 18px;
            border: none;
            border-radius: 50%;
            background: rgba(17, 24, 39, 0.72);
            color: #fff;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
            cursor: pointer;
            padding: 0;
            z-index: 3;
            transition: background 0.2s ease;

            &:hover {
              background: rgba(235, 73, 73, 0.92);
            }
          }

          .pay-voucher-panel {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            gap: 12px;
            justify-content: flex-start;

            .pay-voucher-title {
              font-size: 14px;
              font-weight: 500;
              color: #606666;
              text-align: left;
              line-height: 20px;
            }

            .pay-voucher-preview {
              flex: 1;
              min-height: 0;
            }
          }

          .pay-voucher-item {
            border: none;
            background: transparent;
            align-items: stretch;
            height: 141px;
            padding: 0;
          }
        }

        .contract-item-left {
          border: none;
          position: relative;

          .tip {
            position: absolute;
            bottom: -20px;
            right: 0;
            font-weight: 400;
            font-size: 12px;
            color: #909595;
            line-height: 17px;
            text-align: left;
            font-style: normal;
          }
        }

        .seller-contract-left {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 20px;
          width: 100%;
          background: transparent;
          padding: 0;
          min-height: 141px;
          box-sizing: border-box;

          .seller-contract-badge {
            position: static;
            flex-shrink: 0;
            margin-top: 0;
          }

          .contract-preview-shell {
            margin-top: 0;
          }

          .contract-preview-uploader {
            width: 100%;
            height: auto;
            min-width: 288px;

            :deep(.el-upload) {
              display: none;
            }

            :deep(.el-upload-list),
            :deep(.el-upload-list--picture-card) {
              margin: 0;
              display: flex;
              align-items: center;
              flex-wrap: nowrap;
              gap: 12px;
            }

            :deep(.el-upload-list__item) {
              width: 88px;
              height: 88px;
              margin: 0;
              border-radius: 10px;
              overflow: hidden;
              border: 1px solid #e5eceb;
              box-shadow: 0 6px 14px rgba(72, 160, 156, 0.08);
            }
          }
        }

        .buyer-contract-left {
          flex: 1;
          width: 100%;
          height: 141px;
          min-height: 141px;
          margin: 0 auto;
          border: none;
          background: transparent;
          flex-direction: row;
          align-items: center;
          justify-content: flex-end;
          gap: 0;

          .buyer-contract-stamp-area {
            flex: 1;
            height: 100%;
            min-width: 0;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            box-sizing: border-box;
            padding-right: 10px;
          }

          .buyer-contract-stamp-badge {
            margin: 0;
            cursor: pointer;
            transition: background 0.2s ease;

            &:hover {
              background: #d63f3f;
            }
          }

          .buyer-contract-upload-tip {
            position: absolute;
            right: 0;
            bottom: -22px;
            width: 160px;
            color: #666666;
            font-size: 13px;
            line-height: 18px;
            text-align: center;
            pointer-events: none;
          }
        }

        &.buyer-contract-content {
          flex: none;
          width: 320px;
          max-width: 100%;
        }

        .contract-footer {
          position: absolute;
          position: absolute;
          bottom: 20px;
          right: 20px;

          .footer-text {
            font-size: 13px;
            color: #48a09c;
            cursor: pointer;
          }
        }
      }
    }
  }
}

.pay-info {
  margin: 0;
  margin-bottom: 18px;
  padding: 0;
  background: #ffffff;
  flex-wrap: wrap;
  row-gap: 20px;

  > .contract-section:not(.pay-info-section) {
    flex: 1 1 calc(50% - 20px);
  }

  .pay-info-section {
    flex: 0 0 100%;
    width: 100%;
    min-width: 0;

    .pay-info-title {
      width: 76px;
      height: clamp(242px, 28vw, 480px);
      margin-right: 0;
      background-position: left center;
      background-size: 84px 100%;

      span {
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0;
      }
    }

    .contract-main {
      height: clamp(242px, 28vw, 480px);
      padding: 0;
      overflow: hidden;
      border: 1px solid #edf1f3;
      border-radius: 0 8px 8px 0;
      background: #ffffff;
      align-items: flex-start;
      flex-direction: column;
    }

    .contract-main .pay-info-actions.contract-actions {
      top: clamp(16px, 2vw, 32px);
      right: clamp(16px, 3vw, 48px);
      align-self: auto;
      gap: 10px;
      margin-bottom: 0;
      max-width: calc(100% - 32px);
      // 付款信息独占整行，操作按钮始终保持在右上角，不与下方卡片交叠。
      flex-wrap: nowrap;
      justify-content: flex-end;

      .pay-action-immediate,
      .pay-action-secondary,
      .pay-action-primary,
      .collection-qr-toggle {
        width: clamp(92px, 10vw, 160px);
        min-width: clamp(92px, 10vw, 160px);
        height: clamp(34px, 3.5vw, 56px);
        box-sizing: border-box;
        padding: 0 !important;
        border-radius: 6px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: clamp(14px, 1.3vw, 20px);
        line-height: 1;
        text-align: center;
        white-space: nowrap;
        word-break: keep-all;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .pay-action-immediate {
        background: #eb4949;
        color: #ffffff;
        box-shadow: none;
      }

      .pay-action-secondary {
        background: #ffffff;
        color: #48a09c;
        border-color: #48a09c;
        box-shadow: 0 2px 8px rgba(72, 160, 156, 0.08);
      }

      .pay-action-primary {
        background: #48a09c;
        border-color: #48a09c;
        color: #ffffff;
      }

      .collection-qr-toggle {
        background: #ffffff;
        color: #48a09c;
        border-color: #48a09c;
      }
    }

    .contract-main .pay-info-content.contract-content {
      width: calc(100% - clamp(32px, 7vw, 120px));
      box-sizing: border-box;
      display: flex;
      gap: clamp(14px, 3vw, 48px);
      margin: clamp(78px, 7vw, 128px) clamp(16px, 3.5vw, 60px) 0;
      align-items: flex-start;
      justify-content: space-between;
      overflow: hidden;

      .collection-qr-item.contract-item,
      .payment-status-item.contract-item,
      .pay-voucher-item.contract-item {
        display: block;
        flex: 1 1 0;
        min-width: 0;
        width: auto;
        gap: 0;
        padding: 0;
        border: none;
        background: transparent;
      }

      .payment-status-item.contract-item {
        height: clamp(132px, 18vw, 320px);
      }

      .collection-qr-item.contract-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: clamp(132px, 18vw, 320px);
        box-sizing: border-box;
        padding: clamp(7px, 1.2vw, 20px);
        border: 1px solid #dce9e8;
        border-top: 3px solid #48a09c;
        border-radius: 12px;
        box-shadow: 0 3px 10px rgba(72, 160, 156, 0.1);
        background: linear-gradient(180deg, #f3fbfa 0%, #ffffff 38%);
        text-align: center;
      }

      .collection-qr-title {
        margin-bottom: clamp(3px, 1vw, 16px);
        color: #3b7774;
        font-size: clamp(13px, 1.5vw, 24px);
        font-weight: 600;
        line-height: 16px;
      }

      .collection-qr-image {
        width: 70%;
        max-width: 230px;
        height: auto;
        aspect-ratio: 1;
        object-fit: contain;
        cursor: pointer;
      }

      .pay-voucher-item.contract-item {
        height: clamp(132px, 18vw, 320px);
      }

      .payment-status-card {
        width: 100%;
        height: clamp(132px, 18vw, 320px);
        box-sizing: border-box;
        padding: clamp(12px, 2.2vw, 36px) clamp(10px, 2vw, 32px) 0;
        border: 1px solid #eeeeee;
        border-top: 3px solid #efb15f;
        border-radius: 12px;
        box-shadow: 0 3px 10px rgba(229, 164, 71, 0.12);
        background: linear-gradient(180deg, #fff9ef 0%, #ffffff 36%);
      }

      .payment-status-header {
        display: flex;
        align-items: center;
        gap: clamp(5px, 1vw, 16px);
        margin-bottom: clamp(10px, 2.5vw, 40px);
      }

      .payment-status-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: clamp(18px, 2.2vw, 34px);
        height: clamp(18px, 2.2vw, 34px);
        border: 2px solid #f4a534;
        border-radius: 50%;
        font-size: clamp(13px, 1.5vw, 22px);
        font-weight: 600;
        line-height: 1;
        color: #f4a534;
        box-sizing: border-box;
      }

      .payment-status-text {
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: clamp(13px, 1.8vw, 28px);
        color: #f4a534;
        line-height: 1.2;
      }

      .payment-status-row {
        display: grid;
        grid-template-columns: auto 1fr;
        align-items: center;
        column-gap: clamp(4px, 1vw, 16px);
        margin-bottom: clamp(8px, 1.8vw, 28px);
        font-family: PingFangSC, PingFang SC;
        font-size: clamp(12px, 1.25vw, 20px);
        line-height: 1.2;
        white-space: nowrap;
      }

      .payment-status-row-total {
        margin-bottom: 0;
      }

      .payment-status-label {
        color: #9da0a6;
        white-space: nowrap;
      }

      .payment-status-value {
        color: #5f6066;
        white-space: nowrap;
      }

      .pay-voucher-card {
        position: relative;
        width: 100%;
        height: clamp(132px, 18vw, 320px);
        box-sizing: border-box;
        border: 1px dashed #b9d3d1;
        border-radius: 12px;
        background: #fbfdfd;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        overflow: hidden;
      }

      .pay-voucher-card.has-file {
        border-style: solid;
        border-color: #ebeef5;
      }

      .pay-voucher-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .pay-voucher-mask {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 34px;
        background: rgba(0, 0, 0, 0.48);
        font-family: PingFangSC, PingFang SC;
        font-size: 12px;
        color: #ffffff;
        line-height: 34px;
        text-align: center;
      }

      .pay-voucher-upload-icon {
        width: clamp(20px, 3vw, 48px);
        height: clamp(20px, 3vw, 48px);
        margin-bottom: clamp(8px, 1.5vw, 24px);
      }

      .pay-voucher-upload-text {
        margin-bottom: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: clamp(12px, 1.5vw, 24px);
        color: #606666;
        line-height: 20px;
        text-align: left;
      }

      .pay-voucher-upload-hint {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: clamp(10px, 1.1vw, 18px);
        color: #999999;
        line-height: 1.4;
        text-align: center;
        width: 100%;
      }
    }
  }

}

// 付款、发货、开票信息保持三栏同一行；收款码只作为付款区内的紧凑预览。
.contract.pay-info {
  // 与上方买卖合同共用同一组外边距和内边距，避免付款行撑出页面宽度。
  width: 100%;
  margin-top: 20px;
  padding: 20px;
  box-sizing: border-box;
  flex-wrap: nowrap;
  row-gap: 0;

  > .contract-section {
    min-width: 0;
  }

  > .contract-section:not(.pay-info-section) {
    flex: 1;
  }

  .pay-info-section {
    flex: 1.06;
    width: auto;

    .pay-info-title {
      width: 56px;
      height: 242px;
      background-size: 64px 250px;

      span {
        font-size: 18px;
        line-height: 20px;
      }
    }

    .contract-main {
      min-width: 0;
      height: 242px;
      padding-top: 20px;
      padding-left: 78px;
      overflow: visible;
      border: none;
      border-radius: 0;
      background: #f7f7f7;
      align-items: center;
      flex-direction: row;
    }

    .contract-main .pay-info-actions.contract-actions {
      top: 20px;
      right: 20px;
      gap: 12px;

      .pay-action-immediate,
      .pay-action-secondary,
      .pay-action-primary,
      .collection-qr-toggle {
        width: auto;
        min-width: 0;
        height: 32px;
        padding: 0 24px !important;
        border-radius: 4px;
        font-size: 14px;
        box-shadow: none;
      }
    }

    .contract-main .pay-info-content.contract-content {
      width: auto;
      margin: 32px 0 0;
      gap: 8px;
      align-items: center;
      justify-content: flex-start;
      overflow: visible;

      .collection-qr-item.contract-item,
      .payment-status-item.contract-item,
      .pay-voucher-item.contract-item {
        flex: 0 0 130px;
        width: 130px;
        height: 141px;
      }

      .collection-qr-item.contract-item {
        flex: 0 0 120px;
        width: 120px;
        padding: 8px 5px;
        justify-content: center;
        border: 1px solid #dce9e8;
        border-top: 2px solid #48a09c;
        border-radius: 6px;
        box-shadow: none;
        background: linear-gradient(180deg, #f3fbfa 0%, #ffffff 44%);
      }

      .collection-qr-title {
        margin-bottom: 6px;
        color: #3b7774;
        font-size: 12px;
        line-height: 16px;
      }

      .collection-qr-image {
        width: 100px;
        max-width: 100px;
        height: 100px;
      }

      .payment-status-card,
      .pay-voucher-card {
        width: 130px;
        height: 143px;
        border-radius: 4px;
      }

      .payment-status-card {
        padding: 16px 10px 0;
        border-top-width: 2px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      }

      .payment-status-header {
        gap: 5px;
        margin-bottom: 10px;
      }

      .payment-status-icon {
        width: 18px;
        height: 18px;
        font-size: 13px;
      }

      .payment-status-text {
        font-size: 13px;
        line-height: 20px;
      }

      .payment-status-row {
        grid-template-columns: 42px 1fr;
        column-gap: 4px;
        margin-bottom: 8px;
        font-size: 12px;
        line-height: 18px;
      }

      .pay-voucher-card {
        border: 2px dashed #d9d9d9;
        background: #ffffff;
      }

      .pay-voucher-upload-icon {
        width: 20px;
        height: 20px;
        margin-bottom: 8px;
      }

      .pay-voucher-upload-text {
        font-size: 12px;
      }

      .pay-voucher-upload-hint {
        font-size: 10px;
        line-height: 15px;
      }
    }
  }
}

.shipping-status-content {
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  margin-top: 32px;
  padding: 0 20px 0 8px;
  box-sizing: border-box;

  .shipping-status-slider {
    position: relative;
    width: 132px;
    height: 156px;
  }

  .shipping-status-preview-card {
    position: relative;
    width: 132px;
    height: 156px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    overflow: hidden;
    background: #ffffff;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(15, 23, 42, 0.12);
    }
  }

  .shipping-status-thumb-image {
    width: 100%;
    height: calc(100% - 26px);
    object-fit: contain;
    display: block;
    background: #f8fafc;
    padding: 8px;
    box-sizing: border-box;
  }

  .shipping-status-thumb-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 34px;
    background: rgba(0, 0, 0, 0.48);
    color: #ffffff;
    font-family: PingFangSC, PingFang SC;
    font-size: 12px;
    line-height: 34px;
    text-align: center;
  }

  .shipping-status-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 20px;
    border: 1px solid #cfe3e1;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.94);
    color: #48a09c;
    font-size: 14px;
    line-height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;

    &.shipping-status-nav-prev {
      left: 4px;
    }

    &.shipping-status-nav-next {
      right: 4px;
    }
  }

  .shipping-status-count {
    position: absolute;
    right: 6px;
    top: 6px;
    z-index: 2;
    padding: 0 6px;
    height: 18px;
    border-radius: 10px;
    background: rgba(17, 24, 39, 0.6);
    color: #fff;
    font-size: 11px;
    line-height: 18px;
  }
}

.supplier {
  width: 108px;
  height: 32px;
  background: #EB4949;
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}

.warehouse-section {
  background: #fff;
  border-top-left-radius:8px ;
  border-top-right-radius: 8px;
  padding: 0 17px;

  .warehouse-tabs {
    display: flex;
    gap: 0;
    background: #FFFFFF;

    .warehouse-tab-item {
      padding: 14px 0;
      cursor: pointer;
      font-size: 16px;
      color: #999999;
      background: transparent;
      transition: all 0.3s;
      position: relative;
      margin-bottom: -2px;
      margin-right: 28px;

      &.active {
        color: #48a09c;
        font-weight: 400;
      }

      &:hover {
        color: #48a09c;
      }
    }
  }

  .warehouse-content {
    display: flex;
    gap: 0;
    border: 1px solid #E6E6E6;

    .warehouse-left {
      flex: 1;
      border-right: 1px solid #E5E5E5;

      .warehose-title {
        background-color: #EBEBEB;
        display: flex;
        height: 40px;
        padding: 0 10px;
        display: flex;
        align-items: center;

      }

      .first-title {
        margin-right: 120px;
      }

        .warehouse-info-row {
          display: flex;
          align-items: center;
          font-size: 14px;

          .void-shipment-button {
            height: 28px;
            margin-left: 16px;
            padding: 0 12px;
            border: 1px solid #d84146;
            border-radius: 14px;
            background: #d84146;
            box-shadow: 0 2px 6px rgba(216, 65, 70, 0.24);
            color: #ffffff;
            font-size: 13px;
            font-weight: 500;
            line-height: 26px;
            cursor: pointer;
            transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

            &:hover {
              background: #bf3036;
              box-shadow: 0 4px 10px rgba(216, 65, 70, 0.32);
              transform: translateY(-1px);
            }
          }

          .void-shipment-status {
            display: inline-flex;
            align-items: center;
            height: 26px;
            margin-left: 16px;
            padding: 0 10px;
            border: 1px solid #efb7b9;
            border-radius: 13px;
            background: #fff1f1;
            color: #c63a3f;
            font-size: 13px;
            font-weight: 500;
          }

          .info-label {
          color: #666666;
          margin-right: 8px;
          min-width: 70px;
        }

        .info-value {
          color: #333333;
          font-weight: 500;
        }
      }

      .logistics-timeline {
        margin-top: 24px;
        padding-left: 20px;

        .timeline-item {
          position: relative;
          padding-left: 24px;
          margin-bottom: 20px;

          &::before {
            content: '';
            position: absolute;
            left: 6px;
            top: 6px;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            border: 1px solid #B7B7B7;
            z-index: 2;
          }

          &.is-latest::before {
            background: #48a09c;
            border: 1px solid #48a09c;
          }

          &::after {
            content: '';
            position: absolute;
            left: 9px;
            top: 18px;
            width: 2px;
            height: calc(100% + 6px);
            background: #E5E5E5;
            z-index: 1;
          }

          &:last-child::after {
            display: none;
          }

          .timeline-content {
            .timeline-time {
              font-size: 12px;
              color: #999999;
              margin-bottom: 4px;
            }

            .timeline-text {
              font-size: 13px;
              color: #333333;
              line-height: 1.6;
            }
          }
        }
      }
    }

    .warehouse-right {
      flex: 1;

      .package-section {
        display: flex;
        flex-direction: column;
        height: 100%;

        .package-header {
          background-color: #EBEBEB;
          display: flex;
          align-items: center;
          height: 40px;

          .package-tabs {
            display: flex;
            gap: 0;
            margin-right: 40px;

            .package-tab-item {
              padding: 0 20px;
              cursor: pointer;
              font-size: 14px;
              color: #999999;
              background: #fff;
              transition: all 0.3s;
              position: relative;
              height: 40px;
              display: flex;
              align-items: center;

              &.active {
                color: #48a09c;
                font-weight: 400;

                &::after {
                  content: '';
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  height: 2px;
                  background: #48a09c;
                  margin: 0 12px;
                }
              }

              &:hover {
                color: #48a09c;
              }
            }
          }

          .package-info {
            display: flex;
            align-items: center;
            font-size: 14px;
            flex: 1;

            .info-label {
              color: #666666;
              margin-right: 8px;

              &:not(:first-child) {
                margin-left: 40px;
              }
            }

            .info-value {
              color: #333333;
              font-weight: 500;
            }
          }
        }

        .package-timeline {
          flex: 1;
          padding: 24px 20px;
          overflow-y: auto;

          .timeline-item {
            position: relative;
            padding-left: 24px;
            margin-bottom: 20px;

            &::before {
              content: '';
              position: absolute;
              left: 6px;
              top: 6px;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              border: 1px solid #B7B7B7;
              background: #fff;
              z-index: 2;
            }

            &.is-latest::before {
              border: 1px solid #48a09c;
            }

            &::after {
              content: '';
              position: absolute;
              left: 9px;
              top: 18px;
              width: 2px;
              height: calc(100% + 6px);
              background: #E5E5E5;
              z-index: 1;
            }

            &:last-child::after {
              display: none;
            }

            .timeline-content {
              .timeline-time {
                font-size: 12px;
                color: #999999;
                margin-bottom: 4px;
              }

              .timeline-text {
                font-size: 13px;
                color: #333333;
                line-height: 1.6;
              }
            }
          }
        }
      }
    }
  }
}

.info-cards-section {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;

  .info-card {
    flex: 1;
    background: #fff;
    border-radius: 8px;
    padding: 0;
    overflow: hidden;

    .card-title {
      display: flex;
      align-items: center;
      height: 40px;
      box-sizing: border-box;
      padding-left: 20px;
      margin-bottom: 0;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      background: linear-gradient(81deg, #FFFFFF 0%, #E5F3F2 100%);

      .title-icon {
        width: 2px;
        height: 18px;
        background: #48a09c;
        border-radius: 2px;
        margin-right: 8px;
      }
    }

    .card-content {
      padding: 20px 26px;

      .content-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0;

        p {
          margin: 0;
        }
      }

      p {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #606666;
        line-height: 20px;
        text-align: left;
        font-style: normal;
      }
    }

    .card-action {
      font-size: 14px;
      color: #48a09c;
      cursor: pointer;
      flex-shrink: 0;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.product-list-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;

  .product-tabs {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    .tab-item {
      padding: 10px 20px;
      cursor: pointer;
      font-size: 14px;
      color: #606666;
      border-bottom: 2px solid transparent;

      &.active {
        color: #48a09c;
        border-bottom-color: #48a09c;
      }
    }
  }

  .product-info-cell {
    padding: 8px 0;

    .product-header {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 8px;

      .product-brand-tag {
        display: inline-block;
        padding: 2px 12px;
        border: 1px solid #48a09c;
        border-radius: 3px;
        color: #48a09c;
        font-size: 12px;
        flex-shrink: 0;
      }

      .product-name {
        font-size: 14px;
        font-weight: 400;
        color: #333;
      }
    }

    .product-detail-line {
      font-size: 12px;
      color: #909399;
      line-height: 20px;

      &.after-sales {
        color: #909399;
      }
    }
  }

  .channel-tag {
    display: inline-block;
    padding: 4px 16px;
    border-radius: 20px;
    font-size: 13px;
    border: 1px solid;

    &.agent {
      color: #e6a23c;
      border-color: #e6a23c;
      background: rgba(230, 162, 60, 0.1);
    }

    &.self {
      color: #409eff;
      border-color: #409eff;
      background: rgba(64, 158, 255, 0.1);
    }

    &.factory {
      color: #9b59b6;
      border-color: #9b59b6;
      background: rgba(155, 89, 182, 0.1);
    }
  }

  .price-text {
    font-size: 14px;
    color: #f56c6c;
  }

  .total-text {
    font-size: 14px;
    color: #333;
  }

  .order-summary {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 16px 20px;
    background: #f7f7f7;
    border-radius: 4px;
    margin-top: 0;

    .summary-left {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-size: 14px;
      color: #333;

      .summary-item {
        display: flex;
        align-items: center;
        gap: 4px;

        .label {
          color: #606666;
        }

        .value {
          color: #333;
        }
      }
    }

    .summary-right {
      display: flex;
      flex-direction: column;
      gap: 8px;
      min-width: 200px;

      .summary-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        gap: 40px;

        .label {
          color: #606666;
          white-space: nowrap;
        }

        .value {
          color: #333;
          font-weight: 400;
          text-align: right;
        }

        &.total {
          margin-top: 4px;
          padding-top: 8px;

          .label {
            font-size: 14px;
            color: #606666;
          }

          .total-amount {
            font-size: 16px;
            color: #f56c6c;
            font-weight: 600;
          }
        }
      }
    }
  }
}

.warehouse-list {
  background: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius:8px;
  padding: 20px;
  margin-bottom: 16px;

  .warehouse-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .header-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      position: relative;
      padding-left: 0;
    }

    .download-link {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #48A09C;
      line-height: 22px;
      text-align: left;
      font-style: normal;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .product-name-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    .brand-tag {
      display: inline-block;
      padding: 2px 12px;
      border: 1px solid #48a09c;
      border-radius: 3px;
      color: #48a09c;
      font-size: 12px;
      flex-shrink: 0;
    }

    .product-text {
      font-size: 14px;
      color: #333;
    }
  }
}

</style>

<style lang="less">
.order-image-viewer {
  position: fixed;
  inset: 0;
  z-index: 2147483647;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.72);
  user-select: none;
}

.order-image-viewer-content {
  position: relative;
  max-width: 92vw;
  max-height: 92vh;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.28);
}

.order-image-viewer-img {
  display: block;
  max-width: 92vw;
  max-height: 92vh;
  object-fit: contain;
}

.order-image-viewer-seal {
  position: absolute;
  width: 210px;
  right: 8%;
  bottom: 8%;
  z-index: 2;
  cursor: grab;
  touch-action: none;
}

.order-image-viewer-seal.is-dragging {
  cursor: grabbing;
}

.order-image-viewer-seal.is-seam-stamp {
  right: -105px;
  bottom: auto;
  top: 50%;
  transform: translateY(-50%);
  cursor: default;
}

.order-image-viewer-close,
.order-image-viewer-nav {
  position: absolute;
  border: none;
  border-radius: 50%;
  background: rgba(44, 48, 54, 0.82);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.order-image-viewer-close {
  top: 32px;
  right: 32px;
  width: 46px;
  height: 46px;
  font-size: 32px;
  line-height: 46px;
}

.order-image-viewer-nav {
  top: 50%;
  width: 48px;
  height: 48px;
  transform: translateY(-50%);
  font-size: 36px;
  line-height: 48px;
}

.order-image-viewer-prev {
  left: 40px;
}

.order-image-viewer-next {
  right: 40px;
}

.order-image-viewer-count,
.order-image-viewer-actions {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(44, 48, 54, 0.82);
  color: #fff;
}

.order-image-viewer-count {
  bottom: 32px;
  padding: 4px 14px;
  border-radius: 14px;
  font-size: 14px;
  line-height: 20px;
}

.order-image-viewer-actions {
  bottom: 28px;
  display: flex;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 22px;
}

.order-image-viewer-count + .order-image-viewer-actions {
  bottom: 64px;
}

.order-image-viewer-action {
  min-width: 82px;
  height: 32px;
  padding: 0 16px;
  border-radius: 4px;
  border: 1px solid #48a09c;
  background: #fff;
  color: #48a09c;
  cursor: pointer;
}

.order-image-viewer-action-primary {
  background: #48a09c;
  color: #fff;
}

.order-image-viewer-action:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
</style>
